webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(53),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = [{"row":"1","total_bill":16.99,"tip":1.01,"sex":"Female","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"2","total_bill":10.34,"tip":1.66,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":3},{"row":"3","total_bill":21.01,"tip":3.5,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":3},{"row":"4","total_bill":23.68,"tip":3.31,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"5","total_bill":24.59,"tip":3.61,"sex":"Female","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"6","total_bill":25.29,"tip":4.71,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"7","total_bill":8.77,"tip":2,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"8","total_bill":26.88,"tip":3.12,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"9","total_bill":15.04,"tip":1.96,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"10","total_bill":14.78,"tip":3.23,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"11","total_bill":10.27,"tip":1.71,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"12","total_bill":35.26,"tip":5,"sex":"Female","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"13","total_bill":15.42,"tip":1.57,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"14","total_bill":18.43,"tip":3,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"15","total_bill":14.83,"tip":3.02,"sex":"Female","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"16","total_bill":21.58,"tip":3.92,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"17","total_bill":10.33,"tip":1.67,"sex":"Female","smoker":"No","day":"Sun","time":"Dinner","size":3},{"row":"18","total_bill":16.29,"tip":3.71,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":3},{"row":"19","total_bill":16.97,"tip":3.5,"sex":"Female","smoker":"No","day":"Sun","time":"Dinner","size":3},{"row":"20","total_bill":20.65,"tip":3.35,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":3},{"row":"21","total_bill":17.92,"tip":4.08,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"22","total_bill":20.29,"tip":2.75,"sex":"Female","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"23","total_bill":15.77,"tip":2.23,"sex":"Female","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"24","total_bill":39.42,"tip":7.58,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":4},{"row":"25","total_bill":19.82,"tip":3.18,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"26","total_bill":17.81,"tip":2.34,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":4},{"row":"27","total_bill":13.37,"tip":2,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"28","total_bill":12.69,"tip":2,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"29","total_bill":21.7,"tip":4.3,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"30","total_bill":19.65,"tip":3,"sex":"Female","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"31","total_bill":9.55,"tip":1.45,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"32","total_bill":18.35,"tip":2.5,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":4},{"row":"33","total_bill":15.06,"tip":3,"sex":"Female","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"34","total_bill":20.69,"tip":2.45,"sex":"Female","smoker":"No","day":"Sat","time":"Dinner","size":4},{"row":"35","total_bill":17.78,"tip":3.27,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"36","total_bill":24.06,"tip":3.6,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":3},{"row":"37","total_bill":16.31,"tip":2,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":3},{"row":"38","total_bill":16.93,"tip":3.07,"sex":"Female","smoker":"No","day":"Sat","time":"Dinner","size":3},{"row":"39","total_bill":18.69,"tip":2.31,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":3},{"row":"40","total_bill":31.27,"tip":5,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":3},{"row":"41","total_bill":16.04,"tip":2.24,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":3},{"row":"42","total_bill":17.46,"tip":2.54,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"43","total_bill":13.94,"tip":3.06,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"44","total_bill":9.68,"tip":1.32,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"45","total_bill":30.4,"tip":5.6,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"46","total_bill":18.29,"tip":3,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"47","total_bill":22.23,"tip":5,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"48","total_bill":32.4,"tip":6,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"49","total_bill":28.55,"tip":2.05,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":3},{"row":"50","total_bill":18.04,"tip":3,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"51","total_bill":12.54,"tip":2.5,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"52","total_bill":10.29,"tip":2.6,"sex":"Female","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"53","total_bill":34.81,"tip":5.2,"sex":"Female","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"54","total_bill":9.94,"tip":1.56,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"55","total_bill":25.56,"tip":4.34,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"56","total_bill":19.49,"tip":3.51,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"57","total_bill":38.01,"tip":3,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":4},{"row":"58","total_bill":26.41,"tip":1.5,"sex":"Female","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"59","total_bill":11.24,"tip":1.76,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"60","total_bill":48.27,"tip":6.73,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":4},{"row":"61","total_bill":20.29,"tip":3.21,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"62","total_bill":13.81,"tip":2,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"63","total_bill":11.02,"tip":1.98,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"64","total_bill":18.29,"tip":3.76,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":4},{"row":"65","total_bill":17.59,"tip":2.64,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":3},{"row":"66","total_bill":20.08,"tip":3.15,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":3},{"row":"67","total_bill":16.45,"tip":2.47,"sex":"Female","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"68","total_bill":3.07,"tip":1,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":1},{"row":"69","total_bill":20.23,"tip":2.01,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"70","total_bill":15.01,"tip":2.09,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"71","total_bill":12.02,"tip":1.97,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"72","total_bill":17.07,"tip":3,"sex":"Female","smoker":"No","day":"Sat","time":"Dinner","size":3},{"row":"73","total_bill":26.86,"tip":3.14,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"74","total_bill":25.28,"tip":5,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"75","total_bill":14.73,"tip":2.2,"sex":"Female","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"76","total_bill":10.51,"tip":1.25,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"77","total_bill":17.92,"tip":3.08,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"78","total_bill":27.2,"tip":4,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":4},{"row":"79","total_bill":22.76,"tip":3,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"80","total_bill":17.29,"tip":2.71,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"81","total_bill":19.44,"tip":3,"sex":"Male","smoker":"Yes","day":"Thur","time":"Lunch","size":2},{"row":"82","total_bill":16.66,"tip":3.4,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"83","total_bill":10.07,"tip":1.83,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":1},{"row":"84","total_bill":32.68,"tip":5,"sex":"Male","smoker":"Yes","day":"Thur","time":"Lunch","size":2},{"row":"85","total_bill":15.98,"tip":2.03,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"86","total_bill":34.83,"tip":5.17,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":4},{"row":"87","total_bill":13.03,"tip":2,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"88","total_bill":18.28,"tip":4,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"89","total_bill":24.71,"tip":5.85,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"90","total_bill":21.16,"tip":3,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"91","total_bill":28.97,"tip":3,"sex":"Male","smoker":"Yes","day":"Fri","time":"Dinner","size":2},{"row":"92","total_bill":22.49,"tip":3.5,"sex":"Male","smoker":"No","day":"Fri","time":"Dinner","size":2},{"row":"93","total_bill":5.75,"tip":1,"sex":"Female","smoker":"Yes","day":"Fri","time":"Dinner","size":2},{"row":"94","total_bill":16.32,"tip":4.3,"sex":"Female","smoker":"Yes","day":"Fri","time":"Dinner","size":2},{"row":"95","total_bill":22.75,"tip":3.25,"sex":"Female","smoker":"No","day":"Fri","time":"Dinner","size":2},{"row":"96","total_bill":40.17,"tip":4.73,"sex":"Male","smoker":"Yes","day":"Fri","time":"Dinner","size":4},{"row":"97","total_bill":27.28,"tip":4,"sex":"Male","smoker":"Yes","day":"Fri","time":"Dinner","size":2},{"row":"98","total_bill":12.03,"tip":1.5,"sex":"Male","smoker":"Yes","day":"Fri","time":"Dinner","size":2},{"row":"99","total_bill":21.01,"tip":3,"sex":"Male","smoker":"Yes","day":"Fri","time":"Dinner","size":2},{"row":"100","total_bill":12.46,"tip":1.5,"sex":"Male","smoker":"No","day":"Fri","time":"Dinner","size":2},{"row":"101","total_bill":11.35,"tip":2.5,"sex":"Female","smoker":"Yes","day":"Fri","time":"Dinner","size":2},{"row":"102","total_bill":15.38,"tip":3,"sex":"Female","smoker":"Yes","day":"Fri","time":"Dinner","size":2},{"row":"103","total_bill":44.3,"tip":2.5,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":3},{"row":"104","total_bill":22.42,"tip":3.48,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"105","total_bill":20.92,"tip":4.08,"sex":"Female","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"106","total_bill":15.36,"tip":1.64,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"107","total_bill":20.49,"tip":4.06,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"108","total_bill":25.21,"tip":4.29,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"109","total_bill":18.24,"tip":3.76,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"110","total_bill":14.31,"tip":4,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"111","total_bill":14,"tip":3,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"112","total_bill":7.25,"tip":1,"sex":"Female","smoker":"No","day":"Sat","time":"Dinner","size":1},{"row":"113","total_bill":38.07,"tip":4,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":3},{"row":"114","total_bill":23.95,"tip":2.55,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"115","total_bill":25.71,"tip":4,"sex":"Female","smoker":"No","day":"Sun","time":"Dinner","size":3},{"row":"116","total_bill":17.31,"tip":3.5,"sex":"Female","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"117","total_bill":29.93,"tip":5.07,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"118","total_bill":10.65,"tip":1.5,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"119","total_bill":12.43,"tip":1.8,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"120","total_bill":24.08,"tip":2.92,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":4},{"row":"121","total_bill":11.69,"tip":2.31,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"122","total_bill":13.42,"tip":1.68,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"123","total_bill":14.26,"tip":2.5,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"124","total_bill":15.95,"tip":2,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"125","total_bill":12.48,"tip":2.52,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"126","total_bill":29.8,"tip":4.2,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":6},{"row":"127","total_bill":8.52,"tip":1.48,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"128","total_bill":14.52,"tip":2,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"129","total_bill":11.38,"tip":2,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"130","total_bill":22.82,"tip":2.18,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":3},{"row":"131","total_bill":19.08,"tip":1.5,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"132","total_bill":20.27,"tip":2.83,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"133","total_bill":11.17,"tip":1.5,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"134","total_bill":12.26,"tip":2,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"135","total_bill":18.26,"tip":3.25,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"136","total_bill":8.51,"tip":1.25,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"137","total_bill":10.33,"tip":2,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"138","total_bill":14.15,"tip":2,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"139","total_bill":16,"tip":2,"sex":"Male","smoker":"Yes","day":"Thur","time":"Lunch","size":2},{"row":"140","total_bill":13.16,"tip":2.75,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"141","total_bill":17.47,"tip":3.5,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"142","total_bill":34.3,"tip":6.7,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":6},{"row":"143","total_bill":41.19,"tip":5,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":5},{"row":"144","total_bill":27.05,"tip":5,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":6},{"row":"145","total_bill":16.43,"tip":2.3,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"146","total_bill":8.35,"tip":1.5,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"147","total_bill":18.64,"tip":1.36,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":3},{"row":"148","total_bill":11.87,"tip":1.63,"sex":"Female","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"149","total_bill":9.78,"tip":1.73,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"150","total_bill":7.51,"tip":2,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"151","total_bill":14.07,"tip":2.5,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"152","total_bill":13.13,"tip":2,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"153","total_bill":17.26,"tip":2.74,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":3},{"row":"154","total_bill":24.55,"tip":2,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"155","total_bill":19.77,"tip":2,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"156","total_bill":29.85,"tip":5.14,"sex":"Female","smoker":"No","day":"Sun","time":"Dinner","size":5},{"row":"157","total_bill":48.17,"tip":5,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":6},{"row":"158","total_bill":25,"tip":3.75,"sex":"Female","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"159","total_bill":13.39,"tip":2.61,"sex":"Female","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"160","total_bill":16.49,"tip":2,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"161","total_bill":21.5,"tip":3.5,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"162","total_bill":12.66,"tip":2.5,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"163","total_bill":16.21,"tip":2,"sex":"Female","smoker":"No","day":"Sun","time":"Dinner","size":3},{"row":"164","total_bill":13.81,"tip":2,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"165","total_bill":17.51,"tip":3,"sex":"Female","smoker":"Yes","day":"Sun","time":"Dinner","size":2},{"row":"166","total_bill":24.52,"tip":3.48,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":3},{"row":"167","total_bill":20.76,"tip":2.24,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":2},{"row":"168","total_bill":31.71,"tip":4.5,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":4},{"row":"169","total_bill":10.59,"tip":1.61,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"170","total_bill":10.63,"tip":2,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"171","total_bill":50.81,"tip":10,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":3},{"row":"172","total_bill":15.81,"tip":3.16,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"173","total_bill":7.25,"tip":5.15,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":2},{"row":"174","total_bill":31.85,"tip":3.18,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":2},{"row":"175","total_bill":16.82,"tip":4,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":2},{"row":"176","total_bill":32.9,"tip":3.11,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":2},{"row":"177","total_bill":17.89,"tip":2,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":2},{"row":"178","total_bill":14.48,"tip":2,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":2},{"row":"179","total_bill":9.6,"tip":4,"sex":"Female","smoker":"Yes","day":"Sun","time":"Dinner","size":2},{"row":"180","total_bill":34.63,"tip":3.55,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":2},{"row":"181","total_bill":34.65,"tip":3.68,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":4},{"row":"182","total_bill":23.33,"tip":5.65,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":2},{"row":"183","total_bill":45.35,"tip":3.5,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":3},{"row":"184","total_bill":23.17,"tip":6.5,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":4},{"row":"185","total_bill":40.55,"tip":3,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":2},{"row":"186","total_bill":20.69,"tip":5,"sex":"Male","smoker":"No","day":"Sun","time":"Dinner","size":5},{"row":"187","total_bill":20.9,"tip":3.5,"sex":"Female","smoker":"Yes","day":"Sun","time":"Dinner","size":3},{"row":"188","total_bill":30.46,"tip":2,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":5},{"row":"189","total_bill":18.15,"tip":3.5,"sex":"Female","smoker":"Yes","day":"Sun","time":"Dinner","size":3},{"row":"190","total_bill":23.1,"tip":4,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":3},{"row":"191","total_bill":15.69,"tip":1.5,"sex":"Male","smoker":"Yes","day":"Sun","time":"Dinner","size":2},{"row":"192","total_bill":19.81,"tip":4.19,"sex":"Female","smoker":"Yes","day":"Thur","time":"Lunch","size":2},{"row":"193","total_bill":28.44,"tip":2.56,"sex":"Male","smoker":"Yes","day":"Thur","time":"Lunch","size":2},{"row":"194","total_bill":15.48,"tip":2.02,"sex":"Male","smoker":"Yes","day":"Thur","time":"Lunch","size":2},{"row":"195","total_bill":16.58,"tip":4,"sex":"Male","smoker":"Yes","day":"Thur","time":"Lunch","size":2},{"row":"196","total_bill":7.56,"tip":1.44,"sex":"Male","smoker":"No","day":"Thur","time":"Lunch","size":2},{"row":"197","total_bill":10.34,"tip":2,"sex":"Male","smoker":"Yes","day":"Thur","time":"Lunch","size":2},{"row":"198","total_bill":43.11,"tip":5,"sex":"Female","smoker":"Yes","day":"Thur","time":"Lunch","size":4},{"row":"199","total_bill":13,"tip":2,"sex":"Female","smoker":"Yes","day":"Thur","time":"Lunch","size":2},{"row":"200","total_bill":13.51,"tip":2,"sex":"Male","smoker":"Yes","day":"Thur","time":"Lunch","size":2},{"row":"201","total_bill":18.71,"tip":4,"sex":"Male","smoker":"Yes","day":"Thur","time":"Lunch","size":3},{"row":"202","total_bill":12.74,"tip":2.01,"sex":"Female","smoker":"Yes","day":"Thur","time":"Lunch","size":2},{"row":"203","total_bill":13,"tip":2,"sex":"Female","smoker":"Yes","day":"Thur","time":"Lunch","size":2},{"row":"204","total_bill":16.4,"tip":2.5,"sex":"Female","smoker":"Yes","day":"Thur","time":"Lunch","size":2},{"row":"205","total_bill":20.53,"tip":4,"sex":"Male","smoker":"Yes","day":"Thur","time":"Lunch","size":4},{"row":"206","total_bill":16.47,"tip":3.23,"sex":"Female","smoker":"Yes","day":"Thur","time":"Lunch","size":3},{"row":"207","total_bill":26.59,"tip":3.41,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":3},{"row":"208","total_bill":38.73,"tip":3,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":4},{"row":"209","total_bill":24.27,"tip":2.03,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"210","total_bill":12.76,"tip":2.23,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"211","total_bill":30.06,"tip":2,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":3},{"row":"212","total_bill":25.89,"tip":5.16,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":4},{"row":"213","total_bill":48.33,"tip":9,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":4},{"row":"214","total_bill":13.27,"tip":2.5,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"215","total_bill":28.17,"tip":6.5,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":3},{"row":"216","total_bill":12.9,"tip":1.1,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"217","total_bill":28.15,"tip":3,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":5},{"row":"218","total_bill":11.59,"tip":1.5,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"219","total_bill":7.74,"tip":1.44,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"220","total_bill":30.14,"tip":3.09,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":4},{"row":"221","total_bill":12.16,"tip":2.2,"sex":"Male","smoker":"Yes","day":"Fri","time":"Lunch","size":2},{"row":"222","total_bill":13.42,"tip":3.48,"sex":"Female","smoker":"Yes","day":"Fri","time":"Lunch","size":2},{"row":"223","total_bill":8.58,"tip":1.92,"sex":"Male","smoker":"Yes","day":"Fri","time":"Lunch","size":1},{"row":"224","total_bill":15.98,"tip":3,"sex":"Female","smoker":"No","day":"Fri","time":"Lunch","size":3},{"row":"225","total_bill":13.42,"tip":1.58,"sex":"Male","smoker":"Yes","day":"Fri","time":"Lunch","size":2},{"row":"226","total_bill":16.27,"tip":2.5,"sex":"Female","smoker":"Yes","day":"Fri","time":"Lunch","size":2},{"row":"227","total_bill":10.09,"tip":2,"sex":"Female","smoker":"Yes","day":"Fri","time":"Lunch","size":2},{"row":"228","total_bill":20.45,"tip":3,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":4},{"row":"229","total_bill":13.28,"tip":2.72,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"230","total_bill":22.12,"tip":2.88,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"231","total_bill":24.01,"tip":2,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":4},{"row":"232","total_bill":15.69,"tip":3,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":3},{"row":"233","total_bill":11.61,"tip":3.39,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"234","total_bill":10.77,"tip":1.47,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"235","total_bill":15.53,"tip":3,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"236","total_bill":10.07,"tip":1.25,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"237","total_bill":12.6,"tip":1,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"238","total_bill":32.83,"tip":1.17,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"239","total_bill":35.83,"tip":4.67,"sex":"Female","smoker":"No","day":"Sat","time":"Dinner","size":3},{"row":"240","total_bill":29.03,"tip":5.92,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":3},{"row":"241","total_bill":27.18,"tip":2,"sex":"Female","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"242","total_bill":22.67,"tip":2,"sex":"Male","smoker":"Yes","day":"Sat","time":"Dinner","size":2},{"row":"243","total_bill":17.82,"tip":1.75,"sex":"Male","smoker":"No","day":"Sat","time":"Dinner","size":2},{"row":"244","total_bill":18.78,"tip":3,"sex":"Female","smoker":"No","day":"Thur","time":"Dinner","size":2}]

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

module.exports = [{"position":"Senior Software Engineer","programming_language":"JavaScript","specialty":"","total_experience":"10","company_experience":0.5,"salary_per_month":3000,"salary_change_for_year":-1000,"city":"Kiev","company_size":"10","company_type":"Outstaffing","sex":"m","age":39,"education":"Two Higher","university":"КНЭУ","student":false,"english_level":"pre intermediate","subject_area":"web development,telecomunication","date":"06/21/2017 08:54:23","User-Agent":"Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Senior QA engineer","programming_language":"","specialty":"Manual QA","total_experience":5,"company_experience":2,"salary_per_month":2185,"salary_change_for_year":100,"city":"Kiev","company_size":"1000","company_type":"Outstaffing","sex":"f","age":27,"education":"Higher","university":"Other","student":false,"english_level":"advanced","subject_area":"Desktop Applications,web development","date":"06/21/2017 08:54:56","User-Agent":"Mozilla/5.0 (Linux; Android 6.0; Redmi Note 4 Build/MRA58K) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.83 Mobile Safari/537.36"},{"position":"Software Engineer","programming_language":"Java","specialty":"","total_experience":3,"company_experience":"less than 3 months","salary_per_month":2500,"salary_change_for_year":600,"city":"Kiev","company_size":"200","company_type":"Outsourcing","sex":"m","age":24,"education":"Higher","university":"НТУУ «КПИ»","student":false,"english_level":"intermediate","subject_area":"web development","date":"06/21/2017 08:56:04","User-Agent":"Mozilla/5.0 (Linux; Android 5.1.1; Redmi 3 Build/LMY47V) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.83 Mobile Safari/537.36"},{"position":"Software Engineer","programming_language":"C#/.NET","specialty":"","total_experience":3,"company_experience":0.5,"salary_per_month":1500,"salary_change_for_year":350,"city":"Kiev","company_size":"1000","company_type":"Outsourcing","sex":"m","age":25,"education":"Higher","university":"НУПТ","student":false,"english_level":"upper intermediate","subject_area":"web development","date":"06/21/2017 08:56:06","User-Agent":"Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/55.0.2883.87 Safari/537.36"},{"position":"Software Engineer","programming_language":"C","specialty":"","total_experience":"10","company_experience":0.5,"salary_per_month":1500,"salary_change_for_year":300,"city":"Kiev","company_size":"10","company_type":"Outsourcing","sex":"m","age":36,"education":"Higher","university":"ЖГТУ","student":false,"english_level":"intermediate","subject_area":"Embedded","date":"06/21/2017 08:57:45","User-Agent":"Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Support","programming_language":"","specialty":"","total_experience":4,"company_experience":3,"salary_per_month":1750,"salary_change_for_year":60,"city":"Lviv","company_size":"1000","company_type":"Grocery","sex":"m","age":28,"education":"Higher","university":"Lvivская sexитехника","student":false,"english_level":"upper intermediate","subject_area":"Desktop Applications","date":"06/21/2017 08:59:55","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Senior Software Engineer","programming_language":"PHP","specialty":"","total_experience":7,"company_experience":2,"salary_per_month":2700,"salary_change_for_year":500,"city":"Kiev","company_size":"200","company_type":"Grocery","sex":"m","age":32,"education":"Higher","university":"НТУУ «КПИ»","student":false,"english_level":"upper intermediate","subject_area":"web development","date":"06/21/2017 09:02:50","User-Agent":"Mozilla/5.0 (Windows NT 6.1; WOW64; rv:53.0) Gecko/20100101 Firefox/53.0"},{"position":"Software Engineer","programming_language":"Java","specialty":"","total_experience":5,"company_experience":5,"salary_per_month":1550,"salary_change_for_year":0,"city":"Zaporozhye","company_size":"50","company_type":"Outsourcing","sex":"m","age":27,"education":"Higher","university":"ЗНТУ","student":false,"english_level":"intermediate","subject_area":"web development","date":"06/21/2017 09:04:47","User-Agent":"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/56.0.2924.87 Safari/537.36"},{"position":"Marketing","programming_language":"","specialty":"","total_experience":3,"company_experience":1,"salary_per_month":1500,"salary_change_for_year":0,"city":"Kharkiv","company_size":"50","company_type":"Outsourcing","sex":"m","age":28,"education":"Higher","university":"ХНЭУ","student":false,"english_level":"upper intermediate","subject_area":"Другое","date":"06/21/2017 09:07:54","User-Agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_5) AppleWebKit/603.2.4 (KHTML, like Gecko) Version/10.1.1 Safari/603.2.4"},{"position":"Software Engineer","programming_language":"Java","specialty":"","total_experience":6,"company_experience":1.5,"salary_per_month":2100,"salary_change_for_year":300,"city":"Vinnitsa","company_size":"1000","company_type":"Grocery","sex":"m","age":28,"education":"Higher","university":"ВНУ им. Даля","student":false,"english_level":"pre intermediate","subject_area":"Gamedev","date":"06/21/2017 09:08:00","User-Agent":"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/59.0.3071.104 Safari/537.36"},{"position":"Business analyst","programming_language":"","specialty":"","total_experience":1.5,"company_experience":1.5,"salary_per_month":1050,"salary_change_for_year":0,"city":"Lviv","company_size":"1000","company_type":"Outsourcing","sex":"m","age":27,"education":"Higher","university":"Lvivская sexитехника","student":false,"english_level":"upper intermediate","subject_area":"web development,telecomunication","date":"06/21/2017 09:08:28","User-Agent":"Mozilla/5.0 (Windows NT 6.3; WOW64; Trident/7.0; rv:11.0) like Gecko"},{"position":"Software Engineer","programming_language":"Python","specialty":"","total_experience":2,"company_experience":"less than 3 months","salary_per_month":2850,"salary_change_for_year":1000,"city":"Kiev","company_size":"1000","company_type":"Outstaffing","sex":"m","age":25,"education":"Higher","university":"НТУУ «КПИ»","student":false,"english_level":"upper intermediate","subject_area":"web development","date":"06/21/2017 09:10:37","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Software Engineer","programming_language":"JavaScript","specialty":"","total_experience":2,"company_experience":1,"salary_per_month":1150,"salary_change_for_year":650,"city":"Kiev","company_size":"50","company_type":"Outsourcing","sex":"m","age":24,"education":"Среднее","university":"","student":false,"english_level":"advanced","subject_area":"web development","date":"06/21/2017 09:10:45","User-Agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_4) AppleWebKit/603.1.30 (KHTML, like Gecko) Version/10.1 Safari/603.1.30"},{"position":"Junior Software Engineer","programming_language":"Java","specialty":"","total_experience":1,"company_experience":1,"salary_per_month":400,"salary_change_for_year":0,"city":"Zaporozhye","company_size":"50","company_type":"Outsourcing","sex":"m","age":22,"education":"Higher","university":"Other","student":false,"english_level":"intermediate","subject_area":"web development","date":"06/21/2017 09:13:07","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Project manager","programming_language":"","specialty":"","total_experience":0.5,"company_experience":0.5,"salary_per_month":350,"salary_change_for_year":150,"city":"Kharkiv","company_size":"50","company_type":"Grocery","sex":"f","age":23,"education":"Higher","university":"ДонНТУ","student":false,"english_level":"pre intermediate","subject_area":"web development","date":"06/21/2017 09:14:26","User-Agent":"Mozilla/5.0 (Windows NT 6.1; WOW64; rv:53.0) Gecko/20100101 Firefox/53.0"},{"position":"Software Engineer","programming_language":"C","specialty":"","total_experience":7,"company_experience":"less than 3 months","salary_per_month":2400,"salary_change_for_year":600,"city":"Kiev","company_size":"50","company_type":"Outsourcing","sex":"m","age":34,"education":"Higher","university":"Other","student":false,"english_level":"upper intermediate","subject_area":"Embedded,telecomunication","date":"06/21/2017 09:19:48","User-Agent":"Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:52.0) Gecko/20100101 Firefox/52.0"},{"position":"Junior Software Engineer","programming_language":"PHP","specialty":"","total_experience":1,"company_experience":1,"salary_per_month":500,"salary_change_for_year":320,"city":"Kiev","company_size":"10","company_type":"Outsourcing","sex":"m","age":26,"education":"Higher","university":"Other","student":false,"english_level":"intermediate","subject_area":"web development","date":"06/21/2017 09:20:47","User-Agent":"Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Business analyst","programming_language":"","specialty":"","total_experience":0.5,"company_experience":0.5,"salary_per_month":400,"salary_change_for_year":0,"city":"Kharkiv","company_size":"50","company_type":"Grocery","sex":"f","age":24,"education":"Higher","university":"ХНУРЭ","student":false,"english_level":"upper intermediate","subject_area":"web development","date":"06/21/2017 09:22:49","User-Agent":"Mozilla/5.0 (Windows NT 10.0; WOW64; rv:53.0) Gecko/20100101 Firefox/53.0"},{"position":"Software Engineer","programming_language":"JavaScript","specialty":"","total_experience":2,"company_experience":"less than 3 months","salary_per_month":1000,"salary_change_for_year":500,"city":"Nikolaev","company_size":"200","company_type":"Grocery","sex":"m","age":23,"education":"Higher","university":"НУК","student":false,"english_level":"pre intermediate","subject_area":"web development,eCommerce","date":"06/21/2017 09:23:07","User-Agent":"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/59.0.3071.104 Safari/537.36"},{"position":"Team lead","programming_language":"","specialty":"","total_experience":3,"company_experience":3,"salary_per_month":1900,"salary_change_for_year":900,"city":"Dnepr","company_size":"10","company_type":"Grocery","sex":"f","age":27,"education":"Higher","university":"НметАУ","student":false,"english_level":"upper intermediate","subject_area":"telecomunication","date":"06/21/2017 09:24:14","User-Agent":"Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Software Engineer","programming_language":"PHP","specialty":"","total_experience":5,"company_experience":0.5,"salary_per_month":2650,"salary_change_for_year":650,"city":"Kiev","company_size":"200","company_type":"Grocery","sex":"m","age":36,"education":"Higher","university":"КНУТД","student":false,"english_level":"basic","subject_area":"web development","date":"06/21/2017 09:27:19","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Junior Software Engineer","programming_language":"PHP","specialty":"","total_experience":0.5,"company_experience":3,"salary_per_month":100,"salary_change_for_year":25,"city":"Dnepr","company_size":"10","company_type":"Grocery","sex":"m","age":32,"education":"Uncoplited Higher","university":"ХАИ","student":false,"english_level":"intermediate","subject_area":"web development,telecomunication","date":"06/21/2017 09:35:47","User-Agent":"Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:54.0) Gecko/20100101 Firefox/54.0"},{"position":"Junior QA engineer","programming_language":"","specialty":"Automation QA","total_experience":0.5,"company_experience":0.5,"salary_per_month":400,"salary_change_for_year":0,"city":"Ровно","company_size":"200","company_type":"Outsourcing","sex":"m","age":22,"education":"Higher","university":"ХНУ им. Каразина","student":false,"english_level":"upper intermediate","subject_area":"Android,web development","date":"06/21/2017 09:37:18","User-Agent":"Mozilla/5.0 (iPad; CPU OS 10_3_1 like Mac OS X) AppleWebKit/603.1.30 (KHTML, like Gecko) CriOS/59.0.3071.102 Mobile/14E304 Safari/602.1"},{"position":"Software Engineer","programming_language":"JavaScript","specialty":"","total_experience":3,"company_experience":2,"salary_per_month":1000,"salary_change_for_year":400,"city":"Vinnitsa","company_size":"50","company_type":"Outsourcing","sex":"m","age":24,"education":"Higher","university":"ВНТУ","student":false,"english_level":"intermediate","subject_area":"Android,web development","date":"06/21/2017 09:42:29","User-Agent":"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/59.0.3071.104 Safari/537.36"},{"position":"Senior QA engineer","programming_language":"","specialty":"Automation QA","total_experience":3,"company_experience":0.25,"salary_per_month":2500,"salary_change_for_year":500,"city":"Kiev","company_size":"1000","company_type":"Grocery","sex":"m","age":29,"education":"Uncoplited Higher","university":"Other","student":false,"english_level":"intermediate","subject_area":"web development,Corp systems","date":"06/21/2017 09:44:33","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Software Engineer","programming_language":"C#/.NET","specialty":"","total_experience":3,"company_experience":2,"salary_per_month":1500,"salary_change_for_year":300,"city":"Dnepr","company_size":"200","company_type":"Outsourcing","sex":"m","age":24,"education":"Higher","university":"ДНУ им. Гончара","student":false,"english_level":"intermediate","subject_area":"web development","date":"06/21/2017 09:44:44","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"QA engineer","programming_language":"","specialty":"General QA","total_experience":2,"company_experience":2,"salary_per_month":1100,"salary_change_for_year":220,"city":"Other","company_size":"1000","company_type":"Other","sex":"f","age":26,"education":"Higher","university":"ЗНТУ","student":false,"english_level":"upper intermediate","subject_area":"Desktop Applications,web development","date":"06/21/2017 09:45:11","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Software Engineer","programming_language":"SQL","specialty":"","total_experience":1.5,"company_experience":"less than 3 months","salary_per_month":615,"salary_change_for_year":0,"city":"Kiev","company_size":"1000","company_type":"Grocery","sex":"m","age":25,"education":"Higher","university":"НТУУ «КПИ»","student":false,"english_level":"pre intermediate","subject_area":"telecomunication","date":"06/21/2017 09:46:05","User-Agent":"Mozilla/5.0 (Linux; Android 6.0; MZ-U20 Build/MRA58K) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/45.0.2454.94 Mobile Safari/537.36"},{"position":"Software Engineer","programming_language":"Java","specialty":"","total_experience":3,"company_experience":3,"salary_per_month":2600,"salary_change_for_year":650,"city":"Dnepr","company_size":"1000","company_type":"Outsourcing","sex":"m","age":26,"education":"Кандидат","university":"НметАУ","student":false,"english_level":"intermediate","subject_area":"web development,Corp systems","date":"06/21/2017 09:47:16","User-Agent":"Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/61.0.3124.11 Safari/537.36"},{"position":"Business analyst","programming_language":"","specialty":"","total_experience":4,"company_experience":3,"salary_per_month":1100,"salary_change_for_year":200,"city":"Kiev","company_size":"10","company_type":"Grocery","sex":"f","age":26,"education":"Higher","university":"НТУУ «КПИ»","student":false,"english_level":"upper intermediate","subject_area":"finance","date":"06/21/2017 09:48:33","User-Agent":"Mozilla/5.0 (Windows NT 6.1; WOW64; rv:53.0) Gecko/20100101 Firefox/53.0"},{"position":"Software Engineer","programming_language":"Java","specialty":"","total_experience":3,"company_experience":3,"salary_per_month":2600,"salary_change_for_year":650,"city":"Dnepr","company_size":"1000","company_type":"Outsourcing","sex":"m","age":26,"education":"Higher","university":"НметАУ","student":false,"english_level":"upper intermediate","subject_area":"web development,finance","date":"06/21/2017 09:48:52","User-Agent":"Mozilla/5.0 (Windows NT 6.1; Win64; x64; Trident/7.0; rv:11.0) like Gecko"},{"position":"Software Engineer","programming_language":"Java","specialty":"","total_experience":4,"company_experience":4,"salary_per_month":2800,"salary_change_for_year":300,"city":"Dnepr","company_size":"1000","company_type":"Outsourcing","sex":"m","age":29,"education":"Higher","university":"НметАУ","student":false,"english_level":"intermediate","subject_area":"web development","date":"06/21/2017 09:50:18","User-Agent":"Mozilla/5.0 (Windows NT 6.1; WOW64; rv:53.0) Gecko/20100101 Firefox/53.0"},{"position":"Software Engineer","programming_language":"Java","specialty":"","total_experience":4,"company_experience":4,"salary_per_month":3100,"salary_change_for_year":400,"city":"Dnepr","company_size":"1000","company_type":"Outsourcing","sex":"m","age":28,"education":"Higher","university":"НметАУ","student":false,"english_level":"upper intermediate","subject_area":"finance,Corp systems","date":"06/21/2017 09:51:31","User-Agent":"Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/54.0.2840.59 Safari/537.36 OPR/41.0.2353.46"},{"position":"Junior Software Engineer","programming_language":"JavaScript","specialty":"","total_experience":2,"company_experience":2,"salary_per_month":950,"salary_change_for_year":350,"city":"Dnepr","company_size":"1000","company_type":"Outsourcing","sex":"m","age":28,"education":"Higher","university":"ДНУ им. Гончара","student":false,"english_level":"intermediate","subject_area":"web development","date":"06/21/2017 09:51:56","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Junior Software Engineer","programming_language":"Python","specialty":"","total_experience":"less than 3 months","company_experience":"less than 3 months","salary_per_month":300,"salary_change_for_year":0,"city":"Kiev","company_size":"50","company_type":"Outsourcing","sex":"m","age":22,"education":"Uncoplited Higher","university":"НТУУ «КПИ»","student":false,"english_level":"intermediate","subject_area":"web development","date":"06/21/2017 09:54:56","User-Agent":"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/59.0.3071.104 Safari/537.36"},{"position":"Junior QA engineer","programming_language":"","specialty":"Manual QA","total_experience":0.25,"company_experience":0.25,"salary_per_month":450,"salary_change_for_year":200,"city":"Kharkiv","company_size":"1000","company_type":"Outstaffing","sex":"f","age":28,"education":"Higher","university":"Other","student":false,"english_level":"advanced","subject_area":"web development","date":"06/21/2017 09:57:38","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Marketing","programming_language":"","specialty":"","total_experience":0.5,"company_experience":0.5,"salary_per_month":200,"salary_change_for_year":350,"city":"Dnepr","company_size":"1000","company_type":"Other","sex":"m","age":38,"education":"Higher","university":"ДонНУ","student":false,"english_level":"basic","subject_area":"eCommerce,Другое","date":"06/21/2017 10:01:18","User-Agent":"Mozilla/5.0 (Windows NT 6.1) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Junior Software Engineer","programming_language":"Swift","specialty":"","total_experience":"less than 3 months","company_experience":"less than 3 months","salary_per_month":400,"salary_change_for_year":0,"city":"Lviv","company_size":"50","company_type":"Стартап","sex":"m","age":20,"education":"Uncoplited Higher","university":"Lvivская sexитехника","student":true,"english_level":"upper intermediate","subject_area":"iOS","date":"06/21/2017 10:01:24","User-Agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_5) AppleWebKit/603.2.4 (KHTML, like Gecko) Version/10.1.1 Safari/603.2.4"},{"position":"Software Engineer","programming_language":"PHP","specialty":"","total_experience":2,"company_experience":2,"salary_per_month":800,"salary_change_for_year":500,"city":"Kharkiv","company_size":"200","company_type":"Outstaffing","sex":"m","age":22,"education":"Uncoplited Higher","university":"Other","student":false,"english_level":"pre intermediate","subject_area":"web development,eCommerce","date":"06/21/2017 10:04:29","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Project manager","programming_language":"","specialty":"","total_experience":9,"company_experience":9,"salary_per_month":485,"salary_change_for_year":80,"city":"Other","company_size":"50","company_type":"Other","sex":"f","age":31,"education":"Higher","university":"Other","student":false,"english_level":"upper intermediate","subject_area":"Corp systems,Другое","date":"06/21/2017 10:04:29","User-Agent":"Mozilla/5.0 (Windows NT 6.3; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Sysadmin","programming_language":"","specialty":"","total_experience":1,"company_experience":1,"salary_per_month":127,"salary_change_for_year":39,"city":"Odessa","company_size":"10","company_type":"Other","sex":"m","age":27,"education":"Техникум / Колледж","university":"","student":false,"english_level":"pre intermediate","subject_area":"telecomunication","date":"06/21/2017 10:06:03","User-Agent":"Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:53.0) Gecko/20100101 Firefox/53.0"},{"position":"QA engineer","programming_language":"","specialty":"Manual QA","total_experience":5,"company_experience":3,"salary_per_month":1200,"salary_change_for_year":50,"city":"Kharkiv","company_size":"1000","company_type":"Outsourcing","sex":"f","age":30,"education":"Higher","university":"ХНУ им. Каразина","student":false,"english_level":"intermediate","subject_area":"eCommerce","date":"06/21/2017 10:06:04","User-Agent":"Mozilla/5.0 (Windows NT 6.3; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Senior QA engineer","programming_language":"","specialty":"Manual QA","total_experience":6,"company_experience":"less than 3 months","salary_per_month":2500,"salary_change_for_year":100,"city":"Kiev","company_size":"1000","company_type":"Outsourcing","sex":"f","age":26,"education":"Higher","university":"КНУ им. Шевченко","student":false,"english_level":"upper intermediate","subject_area":"web development,Corp systems","date":"06/21/2017 10:09:20","User-Agent":"Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/59.0.3071.86 Safari/537.36"},{"position":"Senior Software Engineer","programming_language":"PHP","specialty":"","total_experience":5,"company_experience":1.5,"salary_per_month":3000,"salary_change_for_year":500,"city":"Kiev","company_size":"200","company_type":"Grocery","sex":"m","age":27,"education":"Higher","university":"ДонНТУ","student":false,"english_level":"intermediate","subject_area":"web development,eCommerce","date":"06/21/2017 10:09:30","User-Agent":"Mozilla/5.0 (Windows NT 6.1; WOW64; rv:53.0) Gecko/20100101 Firefox/53.0"},{"position":"Senior Software Engineer","programming_language":"C++","specialty":"","total_experience":"10","company_experience":1.5,"salary_per_month":4000,"salary_change_for_year":0,"city":"Kiev","company_size":"200","company_type":"Outsourcing","sex":"m","age":34,"education":"Higher","university":"НТУУ «КПИ»","student":false,"english_level":"upper intermediate","subject_area":"Embedded,Corp systems","date":"06/21/2017 10:09:46","User-Agent":"Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:54.0) Gecko/20100101 Firefox/54.0"},{"position":"Junior Software Engineer","programming_language":"JavaScript","specialty":"","total_experience":0.25,"company_experience":0.25,"salary_per_month":700,"salary_change_for_year":300,"city":"Kiev","company_size":"10","company_type":"Outsourcing","sex":"m","age":26,"education":"Higher","university":"ХНУ [г. Хмельницкий]","student":false,"english_level":"pre intermediate","subject_area":"web development","date":"06/21/2017 10:16:15","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Senior QA engineer","programming_language":"","specialty":"Manual QA","total_experience":5,"company_experience":4,"salary_per_month":1550,"salary_change_for_year":100,"city":"Dnepr","company_size":"1000","company_type":"Grocery","sex":"m","age":30,"education":"Higher","university":"Other","student":false,"english_level":"intermediate","subject_area":"Desktop Applications","date":"06/21/2017 10:17:39","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/59.0.3071.86 Safari/537.36"},{"position":"Marketing","programming_language":"","specialty":"","total_experience":5,"company_experience":1,"salary_per_month":1000,"salary_change_for_year":0,"city":"Kiev","company_size":"50","company_type":"Outsourcing","sex":"f","age":29,"education":"Higher","university":"КНУТД","student":false,"english_level":"upper intermediate","subject_area":"web development","date":"06/21/2017 10:18:20","User-Agent":"Mozilla/5.0 (Linux; Android 5.0.2; Redmi Note 2 Build/LRX22G) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/51.0.2704.81 Mobile Safari/537.36"},{"position":"Software Engineer","programming_language":"JavaScript","specialty":"","total_experience":2,"company_experience":"less than 3 months","salary_per_month":1900,"salary_change_for_year":1200,"city":"Kharkiv","company_size":"200","company_type":"Outsourcing","sex":"m","age":22,"education":"Uncoplited Higher","university":"ЖГТУ","student":false,"english_level":"advanced","subject_area":"web development","date":"06/21/2017 10:21:23","User-Agent":"Mozilla/5.0 (Linux; Android 5.1; ZTE T620 Build/LMY47D) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/57.0.2987.132 Mobile Safari/537.36"},{"position":"Software Engineer","programming_language":"JavaScript","specialty":"","total_experience":3,"company_experience":1.5,"salary_per_month":2000,"salary_change_for_year":1000,"city":"Kharkiv","company_size":"50","company_type":"Outsourcing","sex":"m","age":26,"education":"Higher","university":"Other","student":false,"english_level":"intermediate","subject_area":"web development","date":"06/21/2017 10:21:24","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Software Engineer","programming_language":"JavaScript","specialty":"","total_experience":7,"company_experience":2,"salary_per_month":700,"salary_change_for_year":0,"city":"Kiev","company_size":"1000","company_type":"Outsourcing","sex":"m","age":33,"education":"Higher","university":"НТУУ «КПИ»","student":false,"english_level":"intermediate","subject_area":"web development,Corp systems","date":"06/21/2017 10:22:09","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Software Engineer","programming_language":"SQL","specialty":"","total_experience":5,"company_experience":1,"salary_per_month":2000,"salary_change_for_year":150,"city":"Kiev","company_size":"1000","company_type":"Grocery","sex":"m","age":29,"education":"Higher","university":"КНУ им. Шевченко","student":false,"english_level":"intermediate","subject_area":"telecomunication","date":"06/21/2017 10:24:00","User-Agent":"Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/59.0.3071.86 Safari/537.36"},{"position":"Junior QA engineer","programming_language":"","specialty":"Manual QA","total_experience":0.5,"company_experience":"less than 3 months","salary_per_month":400,"salary_change_for_year":100,"city":"Lviv","company_size":"10","company_type":"Стартап","sex":"f","age":23,"education":"Higher","university":"Lvivская sexитехника","student":false,"english_level":"upper intermediate","subject_area":"Desktop Applications,web development","date":"06/21/2017 10:24:15","User-Agent":"Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/57.0.2987.133 Safari/537.36"},{"position":"QA engineer","programming_language":"","specialty":"Manual QA","total_experience":1.5,"company_experience":1.5,"salary_per_month":600,"salary_change_for_year":300,"city":"Cherkassy","company_size":"200","company_type":"Outsourcing","sex":"f","age":30,"education":"Higher","university":"Other","student":false,"english_level":"intermediate","subject_area":"web development","date":"06/21/2017 10:25:59","User-Agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_11_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Business analyst","programming_language":"","specialty":"","total_experience":0.5,"company_experience":0.5,"salary_per_month":231,"salary_change_for_year":0,"city":"Kiev","company_size":"50","company_type":"Grocery","sex":"f","age":21,"education":"Higher","university":"НТУУ «КПИ»","student":false,"english_level":"advanced","subject_area":"finance","date":"06/21/2017 10:27:55","User-Agent":"Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; rv:11.0) like Gecko"},{"position":"Software Engineer","programming_language":"Objective-C","specialty":"","total_experience":4,"company_experience":2,"salary_per_month":2250,"salary_change_for_year":400,"city":"Odessa","company_size":"10","company_type":"Grocery","sex":"m","age":26,"education":"Uncoplited Higher","university":"ОНУ им. Мечникова","student":false,"english_level":"pre intermediate","subject_area":"iOS","date":"06/21/2017 10:29:22","User-Agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_4) AppleWebKit/603.1.20 (KHTML, like Gecko) Version/10.1 Safari/603.1.20"},{"position":"Senior QA engineer","programming_language":"","specialty":"Manual QA","total_experience":3,"company_experience":3,"salary_per_month":1800,"salary_change_for_year":200,"city":"Kiev","company_size":"1000","company_type":"Outsourcing","sex":"m","age":32,"education":"Higher","university":"Other","student":false,"english_level":"intermediate","subject_area":"Corp systems","date":"06/21/2017 10:30:04","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Project manager","programming_language":"","specialty":"","total_experience":1.5,"company_experience":"less than 3 months","salary_per_month":2000,"salary_change_for_year":500,"city":"Kiev","company_size":"200","company_type":"Grocery","sex":"m","age":28,"education":"Higher","university":"НТУУ «КПИ»","student":false,"english_level":"upper intermediate","subject_area":"Gamedev","date":"06/21/2017 10:30:42","User-Agent":"Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Senior Software Engineer","programming_language":"Java","specialty":"","total_experience":5,"company_experience":1,"salary_per_month":2500,"salary_change_for_year":0,"city":"Lviv","company_size":"1000","company_type":"Outsourcing","sex":"m","age":36,"education":"Higher","university":"НАУ","student":false,"english_level":"upper intermediate","subject_area":"Corp systems","date":"06/21/2017 10:34:51","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Project manager","programming_language":"","specialty":"","total_experience":5,"company_experience":1,"salary_per_month":2300,"salary_change_for_year":400,"city":"Vinnitsa","company_size":"50","company_type":"Grocery","sex":"m","age":33,"education":"Two Higher","university":"ДонНУ","student":false,"english_level":"intermediate","subject_area":"Gamedev","date":"06/21/2017 10:36:32","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Senior Project Manager / Program Manager","programming_language":"","specialty":"","total_experience":7,"company_experience":7,"salary_per_month":3500,"salary_change_for_year":0,"city":"Kharkiv","company_size":"1000","company_type":"Grocery","sex":"f","age":30,"education":"Higher","university":"ХНУ им. Каразина","student":false,"english_level":"upper intermediate","subject_area":"Gamedev","date":"06/21/2017 10:38:31","User-Agent":"Mozilla/5.0 (Windows NT 6.3; WOW64; rv:53.0) Gecko/20100101 Firefox/53.0"},{"position":"Software Engineer","programming_language":"C#/.NET","specialty":"","total_experience":6,"company_experience":3,"salary_per_month":700,"salary_change_for_year":100,"city":"Other","company_size":"200","company_type":"Outsourcing","sex":"m","age":29,"education":"Higher","university":"Other","student":false,"english_level":"intermediate","subject_area":"iOS","date":"06/21/2017 10:38:37","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 OPR/45.0.2552.898"},{"position":"QA engineer","programming_language":"","specialty":"Manual QA","total_experience":3,"company_experience":1,"salary_per_month":500,"salary_change_for_year":0,"city":"Kiev","company_size":"10","company_type":"Grocery","sex":"m","age":28,"education":"Higher","university":"НАУ","student":false,"english_level":"basic","subject_area":"Desktop Applications","date":"06/21/2017 10:38:59","User-Agent":"Mozilla/5.0 (Windows NT 6.3; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 OPR/45.0.2552.888"},{"position":"Software Engineer","programming_language":"Python","specialty":"","total_experience":3,"company_experience":1,"salary_per_month":1100,"salary_change_for_year":500,"city":"Kharkiv","company_size":"50","company_type":"Outstaffing","sex":"m","age":23,"education":"Higher","university":"ХАИ","student":false,"english_level":"upper intermediate","subject_area":"web development","date":"06/21/2017 10:40:31","User-Agent":"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/59.0.3071.104 Safari/537.36"},{"position":"Technical Lead","programming_language":"PHP","specialty":"","total_experience":5,"company_experience":5,"salary_per_month":3000,"salary_change_for_year":2500,"city":"Ivano-Frankovsk","company_size":"50","company_type":"Grocery","sex":"m","age":28,"education":"Higher","university":"Other","student":false,"english_level":"upper intermediate","subject_area":"web development","date":"06/21/2017 10:41:15","User-Agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_5) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Software Engineer","programming_language":"JavaScript","specialty":"","total_experience":5,"company_experience":2,"salary_per_month":2500,"salary_change_for_year":300,"city":"Kiev","company_size":"1000","company_type":"Outstaffing","sex":"m","age":29,"education":"Среднее","university":"","student":false,"english_level":"intermediate","subject_area":"web development,eCommerce","date":"06/21/2017 10:41:29","User-Agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_10_5) AppleWebKit/603.1.30 (KHTML, like Gecko) Version/10.1 Safari/603.1.30"},{"position":"Junior QA engineer","programming_language":"","specialty":"Manual QA","total_experience":0.5,"company_experience":0.5,"salary_per_month":380,"salary_change_for_year":80,"city":"Lviv","company_size":"1000","company_type":"Outsourcing","sex":"f","age":28,"education":"Higher","university":"Other","student":false,"english_level":"intermediate","subject_area":"Android,Desktop Applications","date":"06/21/2017 10:42:29","User-Agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"},{"position":"Software Engineer","programming_language":"SQL","specialty":"","total_experience":6,"company_experience":1,"salary_per_month":1200,"salary_change_for_year":300,"city":"Kiev","company_size":"1000","company_type":"Other","sex":"m","age":30,"education":"Higher","university":"ХНЭУ","student":false,"english_level":"upper intermediate","subject_area":"finance,eCommerce","date":"06/21/2017 10:43:42","User-Agent":"Mozilla/5.0 (Mobile; Windows Phone 8.1; Android 4.0; ARM; Trident/7.0; Touch; rv:11.0; IEMobile/11.0; NOKIA; Lumia 730 Dual SIM) like iPhone OS 7_0_3 Mac OS X AppleWebKit/537 (KHTML, like Gecko) Mobile Safari/537"},{"position":"QA engineer","programming_language":"","specialty":"General QA","total_experience":3,"company_experience":2,"salary_per_month":2100,"salary_change_for_year":600,"city":"Kiev","company_size":"200","company_type":"Outsourcing","sex":"f","age":27,"education":"Higher","university":"Other","student":false,"english_level":"upper intermediate","subject_area":"web development,Corp systems","date":"06/21/2017 10:44:51","User-Agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_4) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"}]

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = [{"date":"2012/01/01","precipitation":0,"temp_max":12.8,"temp_min":5,"wind":4.7,"weather":"drizzle"},{"date":"2012/01/02","precipitation":10.9,"temp_max":10.6,"temp_min":2.8,"wind":4.5,"weather":"rain"},{"date":"2012/02/06","precipitation":0,"temp_max":16.1,"temp_min":1.7,"wind":5,"weather":"sun"},{"date":"2012/02/07","precipitation":0.3,"temp_max":15.6,"temp_min":7.8,"wind":5.3,"weather":"rain"},{"date":"2012/02/08","precipitation":2.8,"temp_max":10,"temp_min":5,"wind":2.7,"weather":"rain"},{"date":"2012/02/09","precipitation":2.5,"temp_max":11.1,"temp_min":7.8,"wind":2.4,"weather":"rain"},{"date":"2012/02/10","precipitation":2.5,"temp_max":12.8,"temp_min":6.7,"wind":3,"weather":"rain"},{"date":"2015/01/26","precipitation":0,"temp_max":16.1,"temp_min":6.1,"wind":2.2,"weather":"fog"},{"date":"2015/01/27","precipitation":0.8,"temp_max":11.1,"temp_min":8.3,"wind":2,"weather":"fog"},{"date":"2015/01/28","precipitation":0,"temp_max":12.2,"temp_min":5,"wind":1.8,"weather":"fog"},{"date":"2015/01/29","precipitation":0,"temp_max":12.2,"temp_min":3.3,"wind":2.9,"weather":"sun"},{"date":"2015/01/30","precipitation":0,"temp_max":8.3,"temp_min":1.1,"wind":0.8,"weather":"fog"},{"date":"2015/01/31","precipitation":0,"temp_max":7.2,"temp_min":3.3,"wind":1.9,"weather":"fog"},{"date":"2015/02/01","precipitation":1.5,"temp_max":9.4,"temp_min":4.4,"wind":2.6,"weather":"fog"},{"date":"2015/02/02","precipitation":7.4,"temp_max":11.1,"temp_min":5,"wind":4,"weather":"fog"},{"date":"2015/02/03","precipitation":1.3,"temp_max":10,"temp_min":5.6,"wind":1.9,"weather":"fog"},{"date":"2015/02/04","precipitation":8.4,"temp_max":10.6,"temp_min":4.4,"wind":1.7,"weather":"fog"},{"date":"2015/02/05","precipitation":26.2,"temp_max":13.3,"temp_min":8.3,"wind":4.6,"weather":"fog"},{"date":"2015/02/06","precipitation":17.3,"temp_max":14.4,"temp_min":10,"wind":4.5,"weather":"fog"},{"date":"2015/02/07","precipitation":23.6,"temp_max":12.2,"temp_min":9.4,"wind":4.6,"weather":"fog"},{"date":"2015/02/08","precipitation":3.6,"temp_max":15,"temp_min":8.3,"wind":3.9,"weather":"fog"},{"date":"2015/02/09","precipitation":6.1,"temp_max":13.3,"temp_min":8.3,"wind":2.5,"weather":"fog"},{"date":"2015/02/10","precipitation":0.3,"temp_max":12.8,"temp_min":8.3,"wind":4,"weather":"fog"},{"date":"2015/02/11","precipitation":0,"temp_max":12.8,"temp_min":5.6,"wind":1,"weather":"fog"},{"date":"2015/02/12","precipitation":1,"temp_max":16.7,"temp_min":9.4,"wind":2.1,"weather":"sun"},{"date":"2015/02/13","precipitation":0,"temp_max":15.6,"temp_min":6.7,"wind":1.7,"weather":"fog"},{"date":"2015/02/14","precipitation":0.3,"temp_max":14.4,"temp_min":6.7,"wind":2.9,"weather":"fog"},{"date":"2015/02/15","precipitation":0,"temp_max":12.2,"temp_min":3.9,"wind":4.8,"weather":"sun"},{"date":"2015/02/16","precipitation":0,"temp_max":15,"temp_min":5.6,"wind":6.6,"weather":"fog"},{"date":"2015/02/17","precipitation":0,"temp_max":16.1,"temp_min":4.4,"wind":4,"weather":"sun"},{"date":"2015/02/18","precipitation":0,"temp_max":12.2,"temp_min":4.4,"wind":2.6,"weather":"sun"},{"date":"2015/02/19","precipitation":4.6,"temp_max":10.6,"temp_min":8.3,"wind":2.2,"weather":"fog"},{"date":"2015/02/20","precipitation":0.8,"temp_max":11.1,"temp_min":7.2,"wind":0.9,"weather":"fog"},{"date":"2015/02/21","precipitation":0,"temp_max":12.2,"temp_min":5.6,"wind":4.5,"weather":"sun"},{"date":"2015/02/22","precipitation":0,"temp_max":11.7,"temp_min":3.3,"wind":4.2,"weather":"sun"},{"date":"2015/02/27","precipitation":18.3,"temp_max":10,"temp_min":6.7,"wind":4,"weather":"fog"},{"date":"2015/02/28","precipitation":0,"temp_max":12.2,"temp_min":3.3,"wind":5.1,"weather":"sun"},{"date":"2015/03/01","precipitation":0,"temp_max":11.1,"temp_min":1.1,"wind":2.2,"weather":"sun"},{"date":"2015/03/02","precipitation":0,"temp_max":11.1,"temp_min":4.4,"wind":4.8,"weather":"sun"},{"date":"2015/03/03","precipitation":0,"temp_max":10.6,"temp_min":0,"wind":2.1,"weather":"sun"},{"date":"2015/03/04","precipitation":0,"temp_max":12.8,"temp_min":-0.5,"wind":1.8,"weather":"sun"},{"date":"2015/03/31","precipitation":1,"temp_max":12.8,"temp_min":6.1,"wind":4.2,"weather":"fog"},{"date":"2015/04/01","precipitation":5.1,"temp_max":12.8,"temp_min":5.6,"wind":3.2,"weather":"rain"},{"date":"2015/04/02","precipitation":0,"temp_max":13.3,"temp_min":5.6,"wind":2.4,"weather":"sun"},{"date":"2015/04/03","precipitation":1.5,"temp_max":11.1,"temp_min":5,"wind":3.6,"weather":"fog"},{"date":"2015/04/04","precipitation":0,"temp_max":12.8,"temp_min":3.9,"wind":1.7,"weather":"sun"},{"date":"2015/04/05","precipitation":0,"temp_max":16.7,"temp_min":2.8,"wind":2.4,"weather":"sun"},{"date":"2015/04/06","precipitation":1,"temp_max":13.9,"temp_min":6.7,"wind":3.5,"weather":"sun"},{"date":"2015/04/07","precipitation":0.5,"temp_max":14.4,"temp_min":6.7,"wind":3.9,"weather":"sun"},{"date":"2015/04/08","precipitation":0,"temp_max":17.2,"temp_min":6.1,"wind":1.7,"weather":"sun"},{"date":"2015/04/09","precipitation":0,"temp_max":17.2,"temp_min":6.1,"wind":2.3,"weather":"sun"},{"date":"2015/04/10","precipitation":10.9,"temp_max":13.9,"temp_min":7.8,"wind":4.6,"weather":"fog"},{"date":"2015/04/11","precipitation":0,"temp_max":11.7,"temp_min":5.6,"wind":6.5,"weather":"sun"},{"date":"2015/04/12","precipitation":0,"temp_max":13.3,"temp_min":5.6,"wind":3.6,"weather":"sun"},{"date":"2015/04/13","precipitation":14,"temp_max":11.7,"temp_min":3.9,"wind":3.6,"weather":"fog"},{"date":"2015/04/14","precipitation":3.3,"temp_max":11.7,"temp_min":2.8,"wind":3.3,"weather":"sun"},{"date":"2015/04/15","precipitation":0,"temp_max":13.9,"temp_min":3.3,"wind":2.4,"weather":"sun"},{"date":"2015/04/16","precipitation":0,"temp_max":17.8,"temp_min":3.9,"wind":3.1,"weather":"sun"},{"date":"2015/04/17","precipitation":0,"temp_max":18.9,"temp_min":6.1,"wind":3.6,"weather":"sun"},{"date":"2015/04/18","precipitation":0,"temp_max":18.9,"temp_min":8.3,"wind":3.9,"weather":"sun"},{"date":"2015/04/19","precipitation":0,"temp_max":21.1,"temp_min":8.3,"wind":3.6,"weather":"sun"},{"date":"2015/04/20","precipitation":0,"temp_max":22.8,"temp_min":7.8,"wind":2.6,"weather":"sun"},{"date":"2015/04/21","precipitation":5.6,"temp_max":17.2,"temp_min":6.7,"wind":3.4,"weather":"fog"},{"date":"2015/04/22","precipitation":0,"temp_max":15.6,"temp_min":5,"wind":2.3,"weather":"sun"},{"date":"2015/04/23","precipitation":3,"temp_max":12.2,"temp_min":6.7,"wind":4.1,"weather":"fog"},{"date":"2015/04/24","precipitation":3.3,"temp_max":12.2,"temp_min":6.1,"wind":5,"weather":"fog"},{"date":"2015/04/25","precipitation":1.3,"temp_max":13.3,"temp_min":5.6,"wind":3,"weather":"fog"},{"date":"2015/04/26","precipitation":0,"temp_max":15.6,"temp_min":4.4,"wind":2.7,"weather":"fog"},{"date":"2015/04/27","precipitation":0.3,"temp_max":25,"temp_min":10.6,"wind":2.3,"weather":"fog"},{"date":"2015/04/28","precipitation":1.8,"temp_max":15.6,"temp_min":8.9,"wind":4.3,"weather":"fog"},{"date":"2015/04/29","precipitation":0,"temp_max":16.1,"temp_min":7.2,"wind":4.7,"weather":"sun"},{"date":"2015/04/30","precipitation":0,"temp_max":17.2,"temp_min":7.8,"wind":2.1,"weather":"sun"},{"date":"2015/05/01","precipitation":0,"temp_max":18.3,"temp_min":8.9,"wind":3.7,"weather":"sun"},{"date":"2015/05/02","precipitation":0,"temp_max":18.3,"temp_min":7.8,"wind":3.7,"weather":"sun"},{"date":"2015/05/03","precipitation":0,"temp_max":20.6,"temp_min":7.8,"wind":2.6,"weather":"sun"},{"date":"2015/05/04","precipitation":0,"temp_max":17.2,"temp_min":7.2,"wind":5.2,"weather":"sun"},{"date":"2015/05/05","precipitation":6.1,"temp_max":14.4,"temp_min":7.2,"wind":5.1,"weather":"fog"},{"date":"2015/05/06","precipitation":0,"temp_max":16.7,"temp_min":7.2,"wind":2.6,"weather":"fog"},{"date":"2015/09/30","precipitation":0,"temp_max":18.3,"temp_min":10,"wind":1.3,"weather":"fog"},{"date":"2015/10/01","precipitation":0,"temp_max":21.1,"temp_min":9.4,"wind":1.3,"weather":"fog"},{"date":"2015/10/02","precipitation":0,"temp_max":15.6,"temp_min":10,"wind":2.9,"weather":"fog"},{"date":"2015/10/03","precipitation":0,"temp_max":19.4,"temp_min":11.1,"wind":4.8,"weather":"sun"},{"date":"2015/10/04","precipitation":0,"temp_max":22.8,"temp_min":10,"wind":3.7,"weather":"sun"},{"date":"2015/10/05","precipitation":0,"temp_max":23.3,"temp_min":9.4,"wind":1.6,"weather":"sun"},{"date":"2015/10/06","precipitation":0,"temp_max":18.3,"temp_min":10,"wind":2.6,"weather":"drizzle"},{"date":"2015/12/31","precipitation":0,"temp_max":5.6,"temp_min":-2.1,"wind":3.5,"weather":"sun"}]

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BarChart = exports.LoadData = exports.UIControls = exports.ScrollReverse = exports.CustomTheme = exports.CustomConfiguration = exports.NoRowsNoCols = exports.ColsOnly = exports.RowsOnly = exports.CalculatedFields = exports.Formatters = exports.Filters = exports.DataTypes = exports.BasicCrosstab = undefined;

var _BasicCrosstab = __webpack_require__(37);

var _BasicCrosstab2 = _interopRequireDefault(_BasicCrosstab);

var _DataTypes = __webpack_require__(42);

var _DataTypes2 = _interopRequireDefault(_DataTypes);

var _Filters = __webpack_require__(43);

var _Filters2 = _interopRequireDefault(_Filters);

var _Formatters = __webpack_require__(44);

var _Formatters2 = _interopRequireDefault(_Formatters);

var _CalculatedFields = __webpack_require__(38);

var _CalculatedFields2 = _interopRequireDefault(_CalculatedFields);

var _RowsOnly = __webpack_require__(47);

var _RowsOnly2 = _interopRequireDefault(_RowsOnly);

var _ColsOnly = __webpack_require__(39);

var _ColsOnly2 = _interopRequireDefault(_ColsOnly);

var _NoRowsNoCols = __webpack_require__(46);

var _NoRowsNoCols2 = _interopRequireDefault(_NoRowsNoCols);

var _CustomConfiguration = __webpack_require__(40);

var _CustomConfiguration2 = _interopRequireDefault(_CustomConfiguration);

var _CustomTheme = __webpack_require__(41);

var _CustomTheme2 = _interopRequireDefault(_CustomTheme);

var _ScrollReverse = __webpack_require__(48);

var _ScrollReverse2 = _interopRequireDefault(_ScrollReverse);

var _UIControls = __webpack_require__(49);

var _UIControls2 = _interopRequireDefault(_UIControls);

var _LoadData = __webpack_require__(45);

var _LoadData2 = _interopRequireDefault(_LoadData);

var _BarChart = __webpack_require__(36);

var _BarChart2 = _interopRequireDefault(_BarChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BasicCrosstab = _BasicCrosstab2.default;
exports.DataTypes = _DataTypes2.default;
exports.Filters = _Filters2.default;
exports.Formatters = _Formatters2.default;
exports.CalculatedFields = _CalculatedFields2.default;
exports.RowsOnly = _RowsOnly2.default;
exports.ColsOnly = _ColsOnly2.default;
exports.NoRowsNoCols = _NoRowsNoCols2.default;
exports.CustomConfiguration = _CustomConfiguration2.default;
exports.CustomTheme = _CustomTheme2.default;
exports.ScrollReverse = _ScrollReverse2.default;
exports.UIControls = _UIControls2.default;
exports.LoadData = _LoadData2.default;
exports.BarChart = _BarChart2.default;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(33)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(54),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(68),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _examples = __webpack_require__(7);

var examples = _interopRequireWildcard(_examples);

var _LangSwitcher = __webpack_require__(10);

var _LangSwitcher2 = _interopRequireDefault(_LangSwitcher);

var _CrosstabExample = __webpack_require__(9);

var _CrosstabExample2 = _interopRequireDefault(_CrosstabExample);

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

__webpack_require__(8);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calculateNavPositions() {
  sections = Array.from(document.querySelectorAll('[data-section]')).map(function (section) {
    return {
      id: section.id,
      offset: section.getBoundingClientRect().top + window.pageYOffset - 50
    };
  });
}

var SL = ', 100%, 85%';
var sections = void 0;

new _vue2.default({
  el: '#app',
  components: _extends({}, examples, {
    CrosstabExample: _CrosstabExample2.default,
    LangSwitcher: _LangSwitcher2.default,
    Crosstab: _vueCrosstab2.default
  }),
  data: function data() {
    return {
      markupLangs: ['pug', 'html'],
      markupLanguage: 'pug',
      isNavSticky: false,
      firstColor: Math.floor(Math.random() * 255),
      secondColor: Math.floor(Math.random() * 255),
      currentPosition: ''
    };
  },

  methods: {
    selectLanguage: function selectLanguage(lang) {
      this.markupLanguage = lang;
    },
    adjustNav: function adjustNav() {
      this.isNavSticky = window.scrollY > window.innerHeight;
      if (!sections) calculateNavPositions();
      for (var i = sections.length - 1; i >= 0; i--) {
        if (window.scrollY > sections[i].offset) {
          this.currentPosition = sections[i].id;
          break;
        }
      }
    },
    onTagging: function onTagging(newTag) {
      this.source.push({ name: newTag, language: newTag });
      this.value.push({ name: newTag, language: newTag });
    }
  },
  mounted: function mounted() {
    this.adjustNav();
    window.addEventListener('scroll', this.adjustNav);
    setTimeout(function () {
      calculateNavPositions();
    }, 1000);
  }
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var colors = {
  'Deep Purple': '#4527A0',
  Indigo: '#283593',
  Pink: '#AD1457',
  Teal: '#00695C',
  Vue: '#41b883',
  'Steel Blue': '#4682b4',
  'Light Blue': '#0277BD',
  Blue: '#1565C0'
};

exports.default = function (_ref) {
  var name = _ref.name,
      baseColor = _ref.baseColor,
      valueColor = _ref.valueColor;

  valueColor = valueColor || '#09622a';

  var hslValueColor = hexToHsl(valueColor);
  var hslColor = hexToHsl(name ? colors[name] : baseColor);
  var palette = [];
  var step = 3;

  for (var i = 0; i < 10; i++) {
    var color = 'hsl(' + hslColor[0] + ', ' + hslColor[1] + '%, ' + (hslColor[2] + i * step) + '%)';
    palette.push(color);
  }

  return {
    palette: palette,
    headerText: '#FFFFFF',
    headerBorder: palette[0],
    cornerBorder: palette[1],
    bodyText: '#666666',
    bodyBorder: '#DADADA',
    bodyPrimary: '#FFFFFF',
    bodySecondary: '#F2F2F2',
    valueToColor: function valueToColor(value, maxValue) {
      var valuePercent = value / maxValue;
      var color = 'hsl(' + hslValueColor[0] + ', ' + hslValueColor[1] + '%, ' + Math.round(70 - 50 * valuePercent) + '%)';

      return color;
    }
  };
};

function hexToRgb(hex) {
  if (hex.charAt && hex.charAt(0) === '#') {
    hex = removeHash(hex);
  }

  if (hex.length === 3) {
    hex = expand(hex);
  }

  var bigint = parseInt(hex, 16);
  var r = bigint >> 16 & 255;
  var g = bigint >> 8 & 255;
  var b = bigint & 255;

  return [r, g, b];
}

function removeHash(hex) {
  var arr = hex.split('');
  arr.shift();
  return arr.join('');
}

function expand(hex) {
  return hex.split('').reduce(function (accum, value) {
    return accum.concat([value, value]);
  }, []).join('');
}

function hexToHsl(hex) {
  var hsl = rgbToHsl.apply(rgbToHsl, hexToRgb(hex));
  return [hsl[0], parseInt(hsl[1], 10), parseInt(hsl[2], 10)];
}

function rgbToHsl(r, g, b) {
  var d = void 0,
      h = void 0,
      l = void 0,
      max = void 0,
      min = void 0,
      s = void 0;
  r /= 255;
  g /= 255;
  b /= 255;
  max = Math.max(r, g, b);
  min = Math.min(r, g, b);
  h = 0;
  s = 0;
  l = (max + min) / 2;
  if (max === min) {
    h = s = 0;
  } else {
    d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
    }
    h /= 6;
  }
  h = Math.ceil(h * 360);
  s = Math.ceil(s * 100) + '%';
  l = Math.ceil(l * 100) + '%';
  return [h, s, l];
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var aggregators = exports.aggregators = {
  count: function count(items) {
    return items.length;
  },
  sum: function sum(items, measure) {
    return Math.round(items.reduce(function (memo, item) {
      return memo + Number.parseFloat(item[measure]);
    }, 0));
  },
  max: function max(items, measure) {
    return Math.round(items.reduce(function (max, item) {
      return max > Number.parseFloat(item[measure]) ? max : Number.parseFloat(item[measure]);
    }, -Infinity));
  },
  min: function min(items, measure) {
    return Math.round(items.reduce(function (min, item) {
      return min < Number.parseFloat(item[measure]) ? min : Number.parseFloat(item[measure]);
    }, Infinity));
  },
  avg: function avg(items, measure) {
    return Math.round(items.reduce(function (total, item) {
      return total + Number.parseFloat(item[measure]);
    }, 0) / items.length);
  }
};

var formatters = exports.formatters = {
  currency: function currency(value) {
    return '$' + Number.parseFloat(value).toLocaleString();
  }
};

var temporalMixin = exports.temporalMixin = function temporalMixin(datum, item) {
  var timeUnit = item.timeUnit;
  var fieldName = item.field;
  var date = new Date(datum[fieldName]);

  if (timeUnit === 'year') {
    datum[fieldName + '_year'] = date.getFullYear();
  }
  if (timeUnit === 'quarter') {
    var month = date.getMonth();

    datum[fieldName + '_quarter'] = month < 3 ? 'Q1' : month < 6 ? 'Q2' : month < 9 ? 'Q3' : 'Q4';
  }
  if (timeUnit === 'month') {
    datum[fieldName + '_month'] = date.toLocaleString('en-us', { month: 'long' });
  }
  if (timeUnit === 'day') {
    datum[fieldName + '_day'] = date.toLocaleString('en-us', { weekday: 'long' });
  }
};

var csvJSON = exports.csvJSON = function csvJSON(csv) {
  var lines = csv.split('\n');
  var result = [];

  var headers = lines[0].split(',').map(function (header) {
    return normalize(header);
  });

  for (var i = 1; i < lines.length; i++) {
    var obj = {};
    var currentline = lines[i].split(',');

    for (var j = 0; j < headers.length; j++) {
      obj[headers[j]] = normalize(currentline[j]);
    }

    result.push(obj);
  }

  return JSON.parse(JSON.stringify(result));
};

function normalize(value) {
  if (/^['|"]/.test(value) && /['|"]$/.test(value)) {
    return value.slice(1, -1);
  }
  return value;
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Crosstab = __webpack_require__(1);

var _Crosstab2 = _interopRequireDefault(_Crosstab);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _salary = __webpack_require__(4);

var _salary2 = _interopRequireDefault(_salary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _Crosstab2.default
  },
  data: function data() {
    return {
      data: _salary2.default,
      transform: [{ calculate: 'sex', value: function value(record) {
          return record.sex === 'm' ? 'Male' : 'Female';
        } }, { filter: 'city', isOneOf: ['Kiev', 'Kharkiv', 'Lviv', 'Odessa', 'Zaporozhye'] }],
      cols: [{ field: 'date', type: 'temporal', timeUnit: 'year', label: 'Year' }, { field: 'city', label: 'City' }, { field: 'sex', label: 'Sex' }, { field: 'salary_per_month', label: 'Salary', aggregate: 'avg', formatter: 'currency' }],
      rows: [{ field: 'programming_language', label: 'Language' }, { field: 'position', label: 'Position' }]
    };
  }
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['langs', 'current'],
  methods: {
    select: function select(lang) {
      this.$emit('select', lang);
    }
  }
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

var _salary = __webpack_require__(4);

var _salary2 = _interopRequireDefault(_salary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _vueCrosstab2.default
  },
  data: function data() {
    return {
      data: _salary2.default,
      transform: [],
      rows: [{ field: 'programming_language', label: 'Speciality' }],
      cols: [{ field: 'salary_per_month', label: 'Salary', aggregate: 'max', formatter: 'currency' }]
    };
  }
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

var _people = __webpack_require__(2);

var _people2 = _interopRequireDefault(_people);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _vueCrosstab2.default
  },
  data: function data() {
    return {
      data: _people2.default,
      cols: [{ field: 'sex' }, { field: 'smoker' }, { field: 'total_bill', aggregate: 'sum', formatter: 'currency' }],
      rows: [{ field: 'day' }, { field: 'time' }]
    };
  }
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _seattleWeatherLite = __webpack_require__(5);

var _seattleWeatherLite2 = _interopRequireDefault(_seattleWeatherLite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _vueCrosstab2.default
  },
  data: function data() {
    return {
      data: _seattleWeatherLite2.default,
      transform: [{
        calculate: 'season',
        value: function value(record) {
          return _underscore2.default.contains(['December', 'January', 'February'], record.date_month) ? 'Winter' : _underscore2.default.contains(['March', 'April', 'May'], record.date_month) ? 'Spring' : _underscore2.default.contains(['June', 'July', 'August'], record.date_month) ? 'Summer' : 'Autumn';
        }
      }],
      cols: [{ field: 'date', type: 'temporal', timeUnit: 'year', label: 'Year' }, { field: 'weather', label: 'Weather', aggregate: 'count' }],
      rows: [{ field: 'season', label: 'Season' }, { field: 'date', type: 'temporal', timeUnit: 'month', label: 'Month' }]
    };
  }
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

var _people = __webpack_require__(2);

var _people2 = _interopRequireDefault(_people);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _vueCrosstab2.default
  },
  data: function data() {
    return {
      data: _people2.default,
      cols: [{ field: 'sex' }, { field: 'smoker', aggregate: 'count' }]
    };
  }
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

var _people = __webpack_require__(2);

var _people2 = _interopRequireDefault(_people);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _vueCrosstab2.default
  },
  data: function data() {
    return {
      data: _people2.default,
      rows: [{ field: 'sex' }, { field: 'smoker' }],
      cols: [{ field: 'time' }, { field: 'total_bill', aggregate: 'sum' }]
    };
  }
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

var _vueMultiselect = __webpack_require__(6);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _people = __webpack_require__(2);

var _people2 = _interopRequireDefault(_people);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _vueCrosstab2.default,
    Multiselect: _vueMultiselect2.default
  },
  data: function data() {
    return {
      data: _people2.default,
      rows: [{ field: 'day' }, { field: 'time' }],
      cols: [{ field: 'sex' }, { field: 'smoker' }, { field: 'total_bill', aggregate: 'sum' }],
      theme: { name: 'Teal' },
      themes: [{ name: 'Blue' }, { name: 'Light Blue' }, { name: 'Indigo' }, { name: 'Pink' }, { name: 'Deep Purple' }, { name: 'Teal' }]
    };
  }
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

var _seattleWeatherLite = __webpack_require__(5);

var _seattleWeatherLite2 = _interopRequireDefault(_seattleWeatherLite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _vueCrosstab2.default
  },
  data: function data() {
    return {
      data: _seattleWeatherLite2.default,
      rows: [{ field: 'date', type: 'temporal', timeUnit: 'year', label: 'Year' }, { field: 'date', type: 'temporal', timeUnit: 'month', label: 'Month' }],
      cols: [{ field: 'date', type: 'temporal', timeUnit: 'day', label: 'Day' }, { field: 'weather', label: 'Weather' }, { field: 'wind', aggregate: 'avg', label: 'Wind' }]
    };
  }
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

var _seattleWeatherLite = __webpack_require__(5);

var _seattleWeatherLite2 = _interopRequireDefault(_seattleWeatherLite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _vueCrosstab2.default
  },
  data: function data() {
    return {
      data: _seattleWeatherLite2.default,
      transform: [{ filter: 'weather', equals: 'sun' }, { filter: 'date_year', isGreaterThan: 2012 }],
      cols: [{ field: 'date', type: 'temporal', timeUnit: 'year', label: 'Year' }, { field: 'weather', label: 'Weather', aggregate: 'count' }],
      rows: [{ field: 'date', type: 'temporal', timeUnit: 'month', label: 'Month' }]
    };
  }
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

var _salary = __webpack_require__(4);

var _salary2 = _interopRequireDefault(_salary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _vueCrosstab2.default
  },
  data: function data() {
    return {
      data: _salary2.default,
      transform: [],
      rows: [{ field: 'programming_language', label: 'Speciality' }],
      cols: [{ field: 'salary_per_month', label: 'Salary', aggregate: 'max', formatter: 'currency' }]
    };
  }
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _vueCrosstab2.default
  },
  data: function data() {
    return {
      dataUrl: 'static/data/seattle-weather-lite.json',
      rows: [{ field: 'date', type: 'temporal', timeUnit: 'year', label: 'Year' }, { field: 'date', type: 'temporal', timeUnit: 'month', label: 'Month' }],
      cols: [{ field: 'date', type: 'temporal', timeUnit: 'day', label: 'Day' }, { field: 'weather', label: 'Weather' }, { field: 'wind', aggregate: 'avg', label: 'Wind' }]
    };
  }
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

var _people = __webpack_require__(2);

var _people2 = _interopRequireDefault(_people);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _vueCrosstab2.default
  },
  data: function data() {
    return {
      data: _people2.default
    };
  }
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

var _people = __webpack_require__(2);

var _people2 = _interopRequireDefault(_people);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _vueCrosstab2.default
  },
  data: function data() {
    return {
      data: _people2.default,
      rows: [{ field: 'sex' }, { field: 'smoker' }, { field: 'total_bill', aggregate: 'sum' }]
    };
  }
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

var _people = __webpack_require__(2);

var _people2 = _interopRequireDefault(_people);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _vueCrosstab2.default
  },
  data: function data() {
    return {
      data: _people2.default,
      cols: [{ field: 'day' }, { field: 'time' }, { field: 'total_bill', aggregate: 'sum' }],
      rows: [{ field: 'sex' }, { field: 'smoker' }]
    };
  }
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCrosstab = __webpack_require__(1);

var _vueCrosstab2 = _interopRequireDefault(_vueCrosstab);

var _people = __webpack_require__(2);

var _people2 = _interopRequireDefault(_people);

var _vueMultiselect = __webpack_require__(6);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Crosstab: _vueCrosstab2.default,
    Multiselect: _vueMultiselect2.default
  },
  data: function data() {
    return {
      data: _people2.default,
      cols: [{ field: 'sex' }, { field: 'smoker' }],
      rows: [{ field: 'time' }, { field: 'day' }]
    };
  },

  computed: {
    fields: function fields() {
      return _underscore2.default.reduce(this.data[0], function (memo, value, key) {
        if (Number.isNaN(Number.parseFloat(value))) {
          return memo.concat({ field: key });
        }
        return memo;
      }, []);
    },
    measures: function measures() {
      return _underscore2.default.reduce(this.data[0], function (memo, value, key) {
        if (!Number.isNaN(Number.parseFloat(value))) {
          return memo.concat({ field: key });
        }
        return memo;
      }, []);
    },
    aggregators: function aggregators() {
      return ['max', 'min', 'avg', 'sum', 'count'];
    }
  }
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _utils = __webpack_require__(14);

var _Scrollbar = __webpack_require__(50);

var _Scrollbar2 = _interopRequireDefault(_Scrollbar);

var _Theme2 = __webpack_require__(13);

var _Theme3 = _interopRequireDefault(_Theme2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Scrollbar: _Scrollbar2.default
  },
  name: 'crosstab',
  data: function data() {
    return {
      values: [],
      dragX: 0,
      dragY: 0,
      parentNodeHeight: Infinity,
      parentNodeWidth: Infinity,
      tmpMaxValue: -Infinity,
      maxValue: -Infinity,

      nextPointX: 0,
      nextPointY: 0,
      previousPointX: 0,
      previousPointY: 0,
      partialScale: 1,
      partialData: []
    };
  },

  props: {
    dataUrl: {
      type: String
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    transform: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rows: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    cols: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bars: {
      type: Boolean,
      default: false
    },
    aggregator: {
      type: String,
      default: 'count'
    },
    width: {},
    height: {},
    cellWidth: {
      type: Number,
      default: 100
    },
    cellHeight: {
      type: Number,
      default: 25
    },
    fontSize: {
      type: Number
    },
    theme: {
      type: Object,
      default: function _default() {
        return {
          name: 'Teal'
        };
      }
    },
    scrollReverse: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    if (this.dataUrl) {
      this.loadData();
    }
  },
  mounted: function mounted() {
    this.parentNodeHeight = Math.floor(this.$el.parentNode.clientHeight);
    this.parentNodeWidth = Math.floor(this.$el.parentNode.clientWidth - 1);

    this.updatePartialRendering();
  },

  computed: {
    rawData: function rawData() {
      if (this.data.length) {
        return this.data;
      }
      return this.values;
    },
    transformedData: function transformedData() {
      var filters = this.transform.filter(function (item) {
        return item.filter;
      });
      var calculations = this.transform.filter(function (item) {
        return item.calculate;
      });
      var data = this.rawData;
      var temporal = this.rows.filter(function (item) {
        return item.type === 'temporal';
      }).concat(this.cols.filter(function (item) {
        return item.type === 'temporal';
      }));

      data.forEach(function (datum) {
        temporal.forEach(function (item) {
          (0, _utils.temporalMixin)(datum, item);
        });
      });

      data.forEach(function (datum) {
        calculations.forEach(function (calculation) {
          datum[calculation.calculate] = calculation.value(datum);
        });
      });

      filters.forEach(function (filter) {
        data = data.filter(function (datum) {
          if (filter.equals) {
            return datum[filter.filter] === filter.equals;
          }
          if (filter.isNotEqualTo) {
            return datum[filter.filter] !== filter.isNotEqualTo;
          }
          if (filter.isOneOf) {
            return _underscore2.default.contains(filter.isOneOf, datum[filter.filter]);
          }
          if (filter.isNotOneOf) {
            return !_underscore2.default.contains(filter.isNotOneOf, datum[filter.filter]);
          }
          if (filter.isGreaterThan) {
            return datum[filter.filter] > filter.isGreaterThan;
          }
          if (filter.isSmallerThan) {
            return datum[filter.filter] < filter.isGreaterThan;
          }
          if (filter.contains) {
            return datum[filter.filter].toLowerCase().indexOf(filter.contains.toLowerCase()) !== -1;
          }
        });
      });

      return data;
    },
    groupedRows: function groupedRows() {
      return groupBy(this.transformedData, this.rows);
    },
    groupedCols: function groupedCols() {
      return groupBy(this.transformedData, this.cols);
    },
    cornerItems: function cornerItems() {
      var _this = this;

      var result = [];
      var isCornerField = true;

      if (this.hasRowsAndCols) {
        this.rows.forEach(function (row, rowIdx) {
          result.push({
            text: getFieldLabel(row, isCornerField),
            x: rowIdx * _this.cellWidth,
            y: _this.cols.length * _this.cellHeight,
            height: _this.cellHeight,
            width: _this.cellWidth,
            textStyle: {
              fontSize: _this.calculatedFontSize,
              fontWeight: 'bold',
              fill: _this.Theme.headerText,
              dx: _this.cellWidth / 2,
              'text-anchor': 'middle',
              textAlign: 'center',
              padding: '0 5px'
            },
            rectStyle: {
              fill: _this.Theme.palette[0],
              stroke: _this.Theme.cornerBorder
            }
          });
        });

        this.cols.forEach(function (col, colIdx) {
          result.push({
            text: getFieldLabel(col, isCornerField),
            x: 0,
            y: colIdx * _this.cellHeight,
            height: _this.cellHeight,
            width: _this.rows.length * _this.cellWidth,
            textStyle: {
              fontSize: _this.calculatedFontSize,
              fontWeight: 'bold',
              fill: _this.Theme.bodyText,
              dx: _this.cellWidth * _this.rows.length - _this.cellWidth / 4,
              'text-anchor': 'end',
              textAlign: 'right',
              padding: '0 10px'
            },
            rectStyle: {
              fill: 'none'
            }
          });
        });
      }

      if (this.hasColsOnly) {
        this.cols.forEach(function (col, colIdx) {
          result.push({
            text: getFieldLabel(col, isCornerField),
            x: 0,
            y: colIdx * _this.cellHeight,
            height: _this.cellHeight,
            width: _this.cellWidth,
            textStyle: {
              fontSize: _this.calculatedFontSize,
              fontWeight: 'bold',
              fill: _this.Theme.bodyText,
              dx: _this.cellWidth - _this.cellWidth / 4,
              'text-anchor': 'end',
              textAlign: 'right',
              padding: '0 10px'
            },
            rectStyle: {
              fill: 'none'
            }
          });
        });
      }

      if (this.hasRowsOnly) {
        this.rows.forEach(function (row, rowIdx) {
          result.push({
            text: getFieldLabel(row, isCornerField),
            x: rowIdx * _this.cellWidth,
            y: 0,
            height: _this.cellHeight,
            width: _this.cellWidth,
            textStyle: {
              fontSize: _this.calculatedFontSize,
              fontWeight: 'bold',
              fill: _this.Theme.headerText,
              dx: _this.cellWidth / 2,
              'text-anchor': 'middle',
              textAlign: 'center'
            },
            rectStyle: {
              fill: _this.Theme.palette[0],
              stroke: _this.Theme.cornerBorder
            }
          });
        });
      }

      return result;
    },
    colItems: function colItems() {
      var _this2 = this;

      if (!this.transformedData.length) return;
      if (this.cols.length) {
        var colsCount = count(this.groupedCols);
        var colItems = this.getColItems(setColPosition(this.groupedCols), this.cellHeight, this.cellWidth);

        var emptyCellItems = _underscore2.default.map(Array(colsCount), function (item, colIdx) {
          return {
            x: colIdx * _this2.cellWidth,
            y: _this2.cols.length * _this2.cellHeight,
            height: _this2.cellHeight,
            width: _this2.cellWidth,
            textStyle: {
              fontSize: _this2.calculatedFontSize,
              fill: _this2.Theme.headerText
            },
            rectStyle: {
              fill: _this2.Theme.bodySecondary,
              stroke: _this2.Theme.bodyBorder
            }
          };
        });

        if (this.rows.length) {
          return colItems.concat(emptyCellItems);
        } else {
          return colItems;
        }
      } else {
        if (this.hasNothing) {} else {
          return [{
            text: 'Totals',
            x: 0,
            y: 0,
            height: this.cellHeight,
            width: this.cellWidth,
            textStyle: {
              fontSize: this.calculatedFontSize,
              fontWeight: 'bold',
              fill: this.Theme.headerText
            },
            rectStyle: {
              fill: this.Theme.palette[0],
              stroke: this.Theme.headerBorder
            }
          }];
        }
      }
    },
    rowItems: function rowItems() {
      if (!this.transformedData.length) return;
      if (this.rows.length) {
        var rowItems = this.getRowItems(setRowPosition(this.groupedRows), this.cellHeight, this.cellWidth);

        if (this.cols.length) {
          return rowItems;
        } else {
          return rowItems;
        }
      } else {
        return [{
          text: 'Totals',
          x: 0,
          y: 0,
          height: this.cellHeight,
          width: this.cellWidth,
          textStyle: {
            fontSize: this.calculatedFontSize,
            fill: this.Theme.headerText,
            fontWeight: 'bold'
          },
          rectStyle: {
            fill: this.Theme.palette[0],
            stroke: this.Theme.headerBorder
          }
        }];
      }
    },
    aggregatedData: function aggregatedData() {
      var _this3 = this;

      if (!this.transformedData.length) return [];

      var rowItems = flat(this.groupedRows);
      var colItems = flat(this.groupedCols);
      var result = [];
      var aggregationInRows = this.rows.find(function (item) {
        return item.aggregate;
      });
      var aggregatedData = aggregationInRows ? aggregateBy(this.transformedData, this.cols.concat(this.rows)) : aggregateBy(this.transformedData, this.rows.concat(this.cols));
      var maxAggregation = aggregationInRows ? getMaxAggregation(this.transformedData, this.cols.concat(this.rows)) : getMaxAggregation(this.transformedData, this.rows.concat(this.cols));

      this.maxValue = maxAggregation.value;

      var isOdd = function isOdd() {
        if (isOdd.prev) {
          isOdd.prev.isOdd = !isOdd.prev.isOdd;
          return isOdd.prev.isOdd;
        } else {
          isOdd.prev = {};
          isOdd.prev.isOdd = true;
          return true;
        }
      };

      _underscore2.default.each(rowItems, function (row, rowIdx) {
        var isOddRow = isOdd();

        _underscore2.default.each(colItems, function (col, colIdx) {
          var value = aggregationInRows ? getValue(aggregatedData, col.concat(row)) : getValue(aggregatedData, row.concat(col));

          result.push({
            text: value && value.formattedAggregation,
            value: value ? value.aggregation : 0,
            x: colIdx * _this3.cellWidth,
            y: rowIdx * _this3.cellHeight,
            isOddRow: isOddRow,
            width: _this3.cellWidth,
            height: _this3.cellHeight
          });
        });
      });

      return result;
    },
    cornerHeight: function cornerHeight() {
      if (this.hasRowsAndCols) {
        return (this.cols.length + 1) * this.cellHeight;
      }
      if (this.hasColsOnly) {
        return this.cols.length * this.cellHeight;
      }
      if (this.hasRowsOnly) {
        return this.cellHeight;
      }
      if (this.hasNothing) {
        return 0;
      }
    },
    cornerWidth: function cornerWidth() {
      if (this.hasRowsAndCols) {
        return this.rows.length * this.cellWidth;
      }
      if (this.hasColsOnly) {
        return this.cellWidth;
      }
      if (this.hasRowsOnly) {
        return this.rows.length * this.cellWidth;
      }
      if (this.hasNothing) {
        return this.cellWidth;
      }
    },
    colHeaderStyle: function colHeaderStyle() {
      return {
        transform: 'translateX(' + (this.cornerWidth + this.dragX) + 'px)'
      };
    },
    rowHeaderStyle: function rowHeaderStyle() {
      return {
        transform: 'translateY(' + (this.cornerHeight + this.dragY) + 'px)'
      };
    },
    dataStyle: function dataStyle() {
      return {
        transform: 'translateX(' + (this.cornerWidth + this.dragX) + 'px) translateY(' + (this.cornerHeight + this.dragY) + 'px)'
      };
    },
    calculatedFontSize: function calculatedFontSize() {
      if (this.fontSize) {
        return this.fontSize;
      }
      return this.cellHeight / 2 < 14 ? this.cellHeight / 2 : 14;
    },
    Theme: function Theme() {
      return (0, _Theme3.default)({ name: this.theme.name });
    },
    calculatedWidth: function calculatedWidth() {
      var fullWidth = this.cellWidth * (this.rows.length + count(this.groupedCols) + (this.hasNothing || this.hasColsOnly ? 1 : 0));

      if (this.width) {
        if (/%$/.test(this.width)) {
          return this.parentNodeWidth * Number.parseInt(this.width) / 100;
        }
        return +this.width > fullWidth ? fullWidth : +this.width;
      } else {
        return fullWidth < this.parentNodeWidth ? fullWidth : this.parentNodeWidth;
      }
    },
    calculatedHeight: function calculatedHeight() {
      var fullHeight = this.cellHeight * (this.cols.length + count(this.groupedRows) + (this.hasRowsAndCols || this.hasRowsOnly ? 1 : 0));

      if (this.height) {
        if (/%$/.test(this.height)) {
          return this.parentNodeHeight * Number.parseInt(this.height) / 100;
        }
        return +this.height > fullHeight ? fullHeight : +this.height;
      } else {
        return fullHeight < this.parentNodeHeight ? fullHeight : this.parentNodeHeight;
      }
    },
    calculatedColumnsWidth: function calculatedColumnsWidth() {
      return count(this.groupedCols) * this.cellWidth;
    },
    calculatedRowsHeight: function calculatedRowsHeight() {
      return count(this.groupedRows) * this.cellHeight;
    },
    hasRowsAndCols: function hasRowsAndCols() {
      return !!(this.rows.length && this.cols.length);
    },
    hasRowsOnly: function hasRowsOnly() {
      return !!(this.rows.length && !this.cols.length);
    },
    hasColsOnly: function hasColsOnly() {
      return !!(this.cols.length && !this.rows.length);
    },
    hasNothing: function hasNothing() {
      return !!(!this.cols.length && !this.rows.length);
    }
  },
  methods: {
    onDragX: function onDragX(value) {
      this.dragX = value;

      if (this.dragX < this.nextPointX || this.dragX > this.previousPointX) {
        this.updatePartialRendering();
      }
    },
    onDragY: function onDragY(value) {
      this.dragY = value;

      if (this.dragY < this.nextPointY || this.dragY > this.previousPointY) {
        this.updatePartialRendering();
      }
    },
    onCellClick: function onCellClick(evt, item) {},
    getTextStyle: function getTextStyle(item) {
      return {
        fontSize: this.calculatedFontSize,
        fill: this.Theme.bodyText
      };
    },
    getRectStyle: function getRectStyle(item) {
      return {
        fill: item.isOddRow ? this.Theme.bodyPrimary : this.Theme.bodySecondary,
        stroke: this.Theme.bodyBorder,
        strokeOpacity: 0.5
      };
    },
    getColItems: function getColItems(item, cellHeight, cellWidth, result) {
      var _this4 = this;

      if (result === undefined) result = [];

      _underscore2.default.each(item.items, function (item) {
        result.push({
          text: item.name,
          x: item.x * cellWidth,
          y: (item.y - 1) * cellHeight,
          height: cellHeight,
          width: count(item) * cellWidth,
          textStyle: {
            fontSize: _this4.calculatedFontSize,
            fill: _this4.Theme.headerText
          },
          rectStyle: {
            fill: _this4.Theme.palette[item.y] || _this4.Theme.palette[6],
            stroke: _this4.Theme.palette[item.y + 1]
          }
        });

        _this4.getColItems(item, cellHeight, cellWidth, result);
      });

      return result;
    },
    getRowItems: function getRowItems(item, cellHeight, cellWidth, result) {
      var _this5 = this;

      if (result === undefined) result = [];

      _underscore2.default.each(item.items, function (item) {
        result.push({
          text: item.name,
          x: (item.x - 1) * cellWidth,
          y: item.y * cellHeight,
          height: count(item) * cellHeight,
          width: cellWidth,
          textStyle: {
            fontSize: _this5.calculatedFontSize,
            fill: _this5.Theme.headerText
          },
          rectStyle: {
            fill: _this5.Theme.palette[item.x] || _this5.Theme.palette[6],
            stroke: _this5.Theme.palette[item.x + 1]
          }
        });

        _this5.getRowItems(item, cellHeight, cellWidth, result);
      });

      return result;
    },
    loadData: function loadData() {
      var _this6 = this;

      var isJSON = /\.json$/.test(this.dataUrl);
      var isCSV = /\.csv$/.test(this.dataUrl);

      var xmlhttp = new window.XMLHttpRequest();
      xmlhttp.open('GET', this.dataUrl, true);
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4) {
          if (xmlhttp.status === 200) {
            if (isJSON) {
              _this6.values = JSON.parse(xmlhttp.responseText);
            }
            if (isCSV) {
              _this6.values = (0, _utils.csvJSON)(xmlhttp.responseText);
            }
            _this6.updatePartialRendering();
          }
        }
      };
      xmlhttp.send(null);
    },
    updatePartialRendering: function updatePartialRendering() {
      var _this7 = this;

      var visibleDataHeight = this.calculatedHeight - this.cornerHeight;
      var visibleDataWidth = this.calculatedWidth - this.cornerWidth;

      this.nextPointX = this.dragX - visibleDataWidth * (this.partialScale - 1);
      this.nextPointY = this.dragY - visibleDataHeight * (this.partialScale - 1);
      this.previousPointX = this.dragX + visibleDataWidth * this.partialScale;
      this.previousPointY = this.dragY + visibleDataHeight * this.partialScale;

      var partialData = this.aggregatedData.filter(function (item) {
        return item.x >= -_this7.cellWidth - _this7.previousPointX && item.x <= visibleDataWidth - _this7.nextPointX && item.y >= -_this7.cellHeight - _this7.previousPointY && item.y <= visibleDataHeight - _this7.nextPointY;
      });

      this.partialData = partialData;
    }
  }
};


function aggregateBy(data, items, levelIdx) {
  if (levelIdx === undefined) {
    levelIdx = 0;

    var tmp = {
      name: 'All'
    };

    if (items.length) {
      tmp.items = aggregateBy(data, items, levelIdx);
    } else {
      tmp.aggregation = data.length;
      tmp.formattedAggregation = data.length;
    }

    return tmp;
  } else {
    if (items[levelIdx].aggregate && items[levelIdx].aggregate === 'count') {
      return _underscore2.default.map(_underscore2.default.groupBy(data, getFieldLabel(items[levelIdx])), function (value, key) {
        var formatter = _utils.formatters[items[levelIdx].formatter] || items[levelIdx].formatter;
        var aggregation = _utils.aggregators[items[levelIdx].aggregate](value, items[levelIdx].field);

        return {
          name: key,
          aggregation: aggregation,
          formattedAggregation: formatter ? formatter(aggregation) : aggregation
        };
      });
    }
    if (items[levelIdx].aggregate) {
      var aggregation = _utils.aggregators[items[levelIdx].aggregate](data, items[levelIdx].field);
      var formatter = _utils.formatters[items[levelIdx].formatter] || items[levelIdx].formatter;

      return [{
        name: items[levelIdx].aggregate,
        aggregation: aggregation,
        formattedAggregation: formatter ? formatter(aggregation) : aggregation
      }];
    }
    return _underscore2.default.map(_underscore2.default.groupBy(data, getFieldLabel(items[levelIdx])), function (value, key) {
      var tmp = {
        name: key
      };

      if (items.length > levelIdx + 1) {
        tmp.items = aggregateBy(value, items, levelIdx + 1);
      }

      return tmp;
    });
  }
}

function getMaxAggregation(data, items, levelIdx, result) {
  if (result === undefined) result = { value: -Infinity };
  if (levelIdx === undefined) {
    levelIdx = 0;

    if (items.length) {
      getMaxAggregation(data, items, levelIdx, result);
    } else {
      result.value = data.length;
    }

    return result;
  } else {
    if (items[levelIdx].aggregate && items[levelIdx].aggregate === 'count') {
      return _underscore2.default.map(_underscore2.default.groupBy(data, getFieldLabel(items[levelIdx])), function (value, key) {
        var aggregation = _utils.aggregators[items[levelIdx].aggregate](value, items[levelIdx].field);

        if (result.value < aggregation) result.value = aggregation;
      });
    }
    if (items[levelIdx].aggregate) {
      var aggregation = _utils.aggregators[items[levelIdx].aggregate](data, items[levelIdx].field);

      if (result.value < aggregation) result.value = aggregation;
    }
    return _underscore2.default.map(_underscore2.default.groupBy(data, getFieldLabel(items[levelIdx])), function (value, key) {
      if (items.length > levelIdx + 1) {
        getMaxAggregation(value, items, levelIdx + 1, result);
      }
    });
  }
}

function groupBy(data, items, levelIdx) {
  if (levelIdx === undefined) {
    levelIdx = 0;

    var tmp = {
      name: 'All'
    };

    if (items.length) {
      tmp.items = groupBy(data, items, levelIdx);
    }

    return tmp;
  } else {
    if (items[levelIdx].aggregate && items[levelIdx].aggregate === 'count') {
      return _underscore2.default.map(_underscore2.default.groupBy(data, getFieldLabel(items[levelIdx])), function (value, key) {
        var tmp = {
          name: key
        };

        if (items.length > levelIdx + 1) {
          tmp.items = groupBy(value, items, levelIdx + 1);
        } else {
          tmp.values = value;
        }
        return tmp;
      });
    }
    if (items[levelIdx].aggregate) {
      return [{
        name: items[levelIdx].aggregate,
        aggregation: _utils.aggregators[items[levelIdx].aggregate](data, items[levelIdx].field)
      }];
    }
    return _underscore2.default.map(_underscore2.default.groupBy(data, getFieldLabel(items[levelIdx])), function (value, key) {
      var tmp = {
        name: key
      };

      if (items.length > levelIdx + 1) {
        tmp.items = groupBy(value, items, levelIdx + 1);
      } else {
        tmp.values = value;
      }
      return tmp;
    });
  }
}

function setColPosition(item, position, levelIdx) {
  if (position === undefined) position = { x: 0, y: 0 };
  if (levelIdx === undefined) levelIdx = 0;

  item.x = position.x;
  item.y = levelIdx;

  if (item.items) {
    item.items.forEach(function (itm, itmIdx) {
      setColPosition(itm, position, levelIdx + 1);
      if (itmIdx !== item.items.length - 1) {
        position.x++;
      }
    });
  }

  return item;
}

function setRowPosition(item, position, levelIdx) {
  if (position === undefined) position = { x: 0, y: 0 };
  if (levelIdx === undefined) levelIdx = 0;

  item.x = levelIdx;
  item.y = position.y;

  if (item.items) {
    item.items.forEach(function (itm, itmIdx) {
      setRowPosition(itm, position, levelIdx + 1);
      if (itmIdx !== item.items.length - 1) {
        position.y++;
      }
    });
  }

  return item;
}

function count(item, result) {
  if (result === undefined) result = { count: 0 };

  if (item.items) {
    item.items.forEach(function (item) {
      count(item, result);
    });
  } else {
    result.count++;
  }

  return result.count;
}

function flat(item, prefix, result) {
  if (prefix === undefined) prefix = [];
  if (result === undefined) result = [];

  if (item.items) {
    item.items.forEach(function (item) {
      flat(item, prefix.concat(item.name), result);
    });
  } else {
    result.push(prefix);
  }

  return result;
}

function getFieldLabel(item, isCornerField) {
  var label = isCornerField && item.label;

  if (item.type === 'temporal') {
    return label || item.field.concat('_', item.timeUnit);
  }

  return label || item.field;
}

function getValue(aggregation, values) {
  var result = findWhere(aggregation, values);

  return result;
}

function findWhere(item, values, levelIdx) {
  if (levelIdx === undefined) levelIdx = 0;
  if (!item) return;

  if (values.length > levelIdx) {
    return findWhere(_underscore2.default.findWhere(item.items, { name: values[levelIdx] }), values, levelIdx + 1);
  } else {
    return item;
  }
}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'scrollbar',

  props: {
    viewportHeight: {
      type: Number,
      default: 0
    },
    viewportWidth: {
      type: Number,
      default: 0
    },
    viewportX: {
      type: Number,
      default: 0
    },
    viewportY: {
      type: Number,
      default: 0
    },
    contentHeight: {
      type: Number,
      default: 0
    },
    contentWidth: {
      type: Number,
      default: 0
    },
    scrollReverse: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      selected: false,
      currentX: 0,
      currentY: 0,
      fromX: 0,
      fromY: 0,
      deltaX: 0,
      deltaY: 0
    };
  },
  mounted: function mounted() {
    this.applyStyles();
  },

  computed: {
    xScrollbarWidth: function xScrollbarWidth() {
      return this.viewportWidth / this.contentWidth * this.viewportWidth;
    },
    yScrollbarHeight: function yScrollbarHeight() {
      return this.viewportHeight / this.contentHeight * this.viewportHeight;
    },
    xScrollbarStyle: function xScrollbarStyle() {
      return {
        transform: 'translateX(' + -(this.currentX + this.deltaX) * this.xScale + 'px)'
      };
    },
    yScrollbarStyle: function yScrollbarStyle() {
      return {
        transform: 'translateY(' + -(this.currentY + this.deltaY) * this.yScale + 'px)'
      };
    },
    isXScrollbarRequired: function isXScrollbarRequired() {
      return this.viewportWidth < this.contentWidth;
    },
    isYScrollbarRequired: function isYScrollbarRequired() {
      return this.viewportHeight < this.contentHeight;
    },
    xScale: function xScale() {
      return this.viewportWidth / this.contentWidth;
    },
    yScale: function yScale() {
      return this.viewportHeight / this.contentHeight;
    }
  },
  methods: {
    select: function select(evt, useScrollBar) {
      this.selected = true;
      this.useScrollBar = useScrollBar;

      this.deltaX = 0;
      this.deltaY = 0;
      this.fromX = evt.clientX;
      this.fromY = evt.clientY;
    },
    move: function move(evt, scrollReverse) {
      if (this.selected) {
        var deltaX = scrollReverse ? this.fromX - evt.clientX : evt.clientX - this.fromX;
        var deltaY = scrollReverse ? this.fromY - evt.clientY : evt.clientY - this.fromY;

        if (this.useScrollBar) {
          deltaX *= this.contentWidth / this.viewportWidth;
          deltaY *= this.contentHeight / this.viewportHeight;
        }

        if (this.currentX + deltaX > 0) deltaX = -this.currentX;
        if (this.currentX + deltaX < this.viewportWidth - this.contentWidth) deltaX = this.viewportWidth - this.contentWidth - this.currentX;
        if (this.currentY + deltaY > 0) deltaY = -this.currentY;
        if (this.currentY + deltaY < this.viewportHeight - this.contentHeight) deltaY = this.viewportHeight - this.contentHeight - this.currentY;

        this.$emit('dragX', this.currentX + deltaX);
        this.$emit('dragY', this.currentY + deltaY);

        this.deltaX = deltaX;
        this.deltaY = deltaY;
      }
    },
    deselect: function deselect() {
      this.selected = false;
      this.useScrollBar = false;

      this.currentX = this.currentX + this.deltaX;
      this.currentY = this.currentY + this.deltaY;

      this.deltaX = 0;
      this.deltaY = 0;
      this.fromX = 0;
      this.fromY = 0;
    },
    mousedown: function mousedown(evt) {
      this.select(evt, true);
    },
    mousemove: function mousemove(evt) {
      this.move(evt, true);
    },
    mouseup: function mouseup(evt) {
      this.deselect(evt);
    },
    mouseleave: function mouseleave(evt) {
      this.deselect(evt);
    },
    touchstart: function touchstart(evt) {
      this.select(evt.touches[0]);
    },
    touchmove: function touchmove(evt) {
      this.move(evt.touches[0]);
    },
    touchend: function touchend(evt) {
      this.deselect(evt.touches[0]);
    },
    mousewheel: function mousewheel(evt) {
      var deltaX = this.scrollReverse ? -evt.deltaX : evt.deltaX;
      var deltaY = this.scrollReverse ? -evt.deltaY : evt.deltaY;

      if (this.currentX + deltaX > 0) deltaX = -this.currentX;
      if (this.currentX + deltaX < this.viewportWidth - this.contentWidth) deltaX = this.viewportWidth - this.contentWidth - this.currentX;
      if (this.currentY + deltaY > 0) deltaY = -this.currentY;
      if (this.currentY + deltaY < this.viewportHeight - this.contentHeight) deltaY = this.viewportHeight - this.contentHeight - this.currentY;

      this.$emit('dragX', this.currentX + deltaX);
      this.$emit('dragY', this.currentY + deltaY);
      this.currentX = this.currentX + deltaX;
      this.currentY = this.currentY + deltaY;
    },
    applyStyles: function applyStyles() {
      var styleEl = document.createElement('style');
      styleEl.innerHTML = styles;
      document.body.appendChild(styleEl);
    }
  }
};


var styles = '\n  svg text {\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n  }\n  svg text::selection {\n      background: none;\n  }\n  .x-scrollbar,\n  .y-scrollbar {\n      transition: fill-opacity .5s;\n      fill-opacity: .3;\n  }\n  .x-scrollbar:hover,\n  .y-scrollbar:hover {\n      fill-opacity: .7;\n  }\n';

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(65),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(63),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(66),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(60),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(58),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(59),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(64),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(51),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(62),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(57),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(52),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(55),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(61),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(35)
__webpack_require__(34)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(56),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(67),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Filters")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('crosstab', {
    attrs: {
      "data": _vm.data,
      "cols": _vm.cols,
      "rows": _vm.rows,
      "transform": _vm.transform
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("No rows and now cols")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('crosstab', {
    attrs: {
      "data": _vm.data
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "height": _vm.calculatedHeight,
      "width": _vm.calculatedWidth
    }
  }, [_c('scrollbar', {
    attrs: {
      "viewportHeight": _vm.calculatedHeight - _vm.cornerHeight,
      "viewportWidth": _vm.calculatedWidth - _vm.cornerWidth,
      "viewportX": _vm.cornerWidth,
      "viewportY": _vm.cornerHeight,
      "contentWidth": _vm.calculatedColumnsWidth,
      "contentHeight": _vm.calculatedRowsHeight,
      "scrollReverse": _vm.scrollReverse
    },
    on: {
      "dragX": _vm.onDragX,
      "dragY": _vm.onDragY
    }
  }, [_c('g', {
    style: (_vm.dataStyle)
  }, [_vm._l((_vm.partialData), function(item) {
    return _c('rect', {
      style: (_vm.getRectStyle(item)),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y
      },
      on: {
        "click": function($event) {
          _vm.onCellClick($event, item)
        },
        "touchstart": function($event) {
          _vm.onCellClick($event, item)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.partialData), function(item) {
    return (_vm.bars) ? _c('rect', {
      attrs: {
        "height": item.height / 4,
        "width": item.width * (item.value / _vm.maxValue),
        "x": item.x,
        "y": item.y,
        "fill": item.value ? _vm.Theme.valueToColor(item.value, _vm.maxValue) : 'none'
      },
      on: {
        "click": function($event) {
          _vm.onCellClick($event, item)
        },
        "touchstart": function($event) {
          _vm.onCellClick($event, item)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.partialData), function(item) {
    return _c('text', {
      style: (_vm.getTextStyle(item)),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y,
        "dy": item.height / 2 + _vm.calculatedFontSize / 2,
        "dx": item.width - 5,
        "text-anchor": "end"
      },
      on: {
        "click": function($event) {
          _vm.onCellClick($event, item)
        },
        "touchstart": function($event) {
          _vm.onCellClick($event, item)
        }
      }
    }, [_vm._v(_vm._s(item.text) + "\n      ")])
  })], 2), _vm._v(" "), _c('g', {
    style: (_vm.colHeaderStyle)
  }, [_vm._l((_vm.colItems), function(item) {
    return _c('rect', {
      style: (item.rectStyle),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y
      }
    })
  }), _vm._v(" "), _vm._l((_vm.colItems), function(item) {
    return _c('foreignObject', {
      key: item.x + '_' + item.y,
      style: (item.textStyle),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y
      }
    }, [_c('div', {
      style: ({
        textAlign: 'center',
        color: _vm.Theme.headerText,
        overflow: 'hidden',
        lineHeight: _vm.cellHeight + 'px',
        userSelect: 'none',
        padding: '0 5px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }),
      attrs: {
        "title": item.text
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2), _vm._v(" "), _c('g', {
    style: (_vm.rowHeaderStyle)
  }, [_vm._l((_vm.rowItems), function(item) {
    return _c('rect', {
      style: (item.rectStyle),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y
      }
    })
  }), _vm._v(" "), _vm._l((_vm.rowItems), function(item) {
    return _c('foreignObject', {
      key: item.x + '_' + item.y,
      style: (item.textStyle),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y
      }
    }, [_c('div', {
      style: ({
        textAlign: 'center',
        color: _vm.Theme.headerText,
        overflow: 'hidden',
        lineHeight: _vm.cellHeight + 'px',
        userSelect: 'none',
        padding: '0 5px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }),
      attrs: {
        "title": item.text
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2), _vm._v(" "), _c('g', [_c('rect', {
    style: (("fill:" + (_vm.Theme.bodyPrimary) + ";stroke:" + (_vm.Theme.headerBorder))),
    attrs: {
      "height": _vm.cornerHeight,
      "width": _vm.cornerWidth
    }
  }), _vm._v(" "), _vm._l((_vm.cornerItems), function(item) {
    return _c('rect', {
      style: (item.rectStyle),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y
      }
    })
  }), _vm._v(" "), _vm._l((_vm.cornerItems), function(item) {
    return _c('foreignObject', {
      key: item.x + '_' + item.y,
      style: (item.textStyle),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y
      }
    }, [_c('div', {
      style: ({
        textAlign: item.textStyle.textAlign,
        color: item.textStyle.fill,
        overflow: 'hidden',
        lineHeight: _vm.cellHeight + 'px',
        userSelect: 'none',
        padding: item.textStyle.padding,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }),
      attrs: {
        "title": item.text
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2), _vm._v(" "), _c('rect', {
    attrs: {
      "height": _vm.calculatedHeight,
      "width": _vm.calculatedWidth,
      "fill": "none",
      "stroke": _vm.Theme.headerBorder
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('crosstab', {
    attrs: {
      "dataUrl": "https://raw.githubusercontent.com/amalieiev/vue-crosstab/master/docs/data/salary.json",
      "rows": _vm.rows,
      "cols": _vm.cols,
      "transform": _vm.transform
    }
  })
},staticRenderFns: []}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Rows Only")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('crosstab', {
    attrs: {
      "data": _vm.data,
      "rows": _vm.rows,
      "cellWidth": 80
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Cols:")]), _c('multiselect', {
    attrs: {
      "options": _vm.fields,
      "multiple": true,
      "label": "field",
      "track-by": "field"
    },
    model: {
      value: (_vm.cols),
      callback: function($$v) {
        _vm.cols = $$v
      },
      expression: "cols"
    }
  }), _c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Rows:")]), _c('multiselect', {
    attrs: {
      "options": _vm.fields,
      "multiple": true,
      "label": "field",
      "track-by": "field"
    },
    model: {
      value: (_vm.rows),
      callback: function($$v) {
        _vm.rows = $$v
      },
      expression: "rows"
    }
  }), _c('br'), _c('crosstab', {
    attrs: {
      "data": _vm.data,
      "rows": _vm.rows,
      "cols": _vm.cols,
      "cellWidth": 60,
      "fontSize": 10,
      "height": "300"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Load data")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('crosstab', {
    attrs: {
      "dataUrl": _vm.dataUrl,
      "cols": _vm.cols,
      "rows": _vm.rows,
      "height": "200"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Basic Crosstab")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('crosstab', {
    attrs: {
      "data": _vm.data,
      "rows": _vm.rows,
      "cols": _vm.cols,
      "cellWidth": 75,
      "cellHeight": 75,
      "fontSize": 20
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Custom Theme")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.themes,
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.theme),
      callback: function($$v) {
        _vm.theme = $$v
      },
      expression: "theme"
    }
  }), _c('br'), _c('br'), _c('crosstab', {
    attrs: {
      "data": _vm.data,
      "rows": _vm.rows,
      "cols": _vm.cols,
      "width": 380,
      "theme": _vm.theme
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Cols Only")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('crosstab', {
    attrs: {
      "data": _vm.data,
      "cols": _vm.cols
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Natural scroll direction")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('crosstab', {
    attrs: {
      "data": _vm.data,
      "rows": _vm.rows,
      "cols": _vm.cols,
      "scrollReverse": false,
      "height": "300"
    }
  })], 1)]), _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Reversed scroll direction (default)")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('crosstab', {
    attrs: {
      "data": _vm.data,
      "rows": _vm.rows,
      "cols": _vm.cols,
      "height": "300"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Filters")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('crosstab', {
    attrs: {
      "data": _vm.data,
      "cols": _vm.cols,
      "rows": _vm.rows,
      "cellWidth": 150,
      "transform": _vm.transform
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Basic Crosstab")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('crosstab', {
    attrs: {
      "data": _vm.data,
      "cols": _vm.cols,
      "rows": _vm.rows
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Data types")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('crosstab', {
    attrs: {
      "data": _vm.data,
      "cols": _vm.cols,
      "rows": _vm.rows
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Filters")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('crosstab', {
    attrs: {
      "data": _vm.data,
      "cols": _vm.cols,
      "rows": _vm.rows,
      "bars": true,
      "cellWidth": 150,
      "transform": _vm.transform
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Calculated fields")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('crosstab', {
    attrs: {
      "data": _vm.data,
      "cols": _vm.cols,
      "rows": _vm.rows,
      "transform": _vm.transform
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    on: {
      "mousemove": _vm.mousemove,
      "mouseup": _vm.mouseup,
      "mouseleave": _vm.mouseleave,
      "touchstart": function($event) {
        $event.preventDefault();
        _vm.touchstart($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        _vm.touchmove($event)
      },
      "touchend": function($event) {
        $event.preventDefault();
        _vm.touchend($event)
      },
      "mousewheel": function($event) {
        $event.preventDefault();
        _vm.mousewheel($event)
      },
      "DOMMouseScroll": function($event) {
        $event.preventDefault();
        _vm.mousewheel($event)
      }
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.isXScrollbarRequired) ? _c('rect', {
    staticClass: "x-scrollbar",
    style: (_vm.xScrollbarStyle),
    attrs: {
      "x": _vm.viewportX,
      "y": _vm.viewportY + _vm.viewportHeight - 6,
      "width": _vm.xScrollbarWidth,
      "height": "5",
      "fill": "gray",
      "rx": "3",
      "ry": "3"
    },
    on: {
      "mousedown": _vm.mousedown
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isYScrollbarRequired) ? _c('rect', {
    staticClass: "y-scrollbar",
    style: (_vm.yScrollbarStyle),
    attrs: {
      "x": _vm.viewportX + _vm.viewportWidth - 6,
      "y": _vm.viewportY,
      "width": "5",
      "height": _vm.yScrollbarHeight,
      "fill": "gray",
      "fill-opacity": ".3",
      "rx": "3",
      "ry": "3"
    },
    on: {
      "mousedown": _vm.mousedown
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.langs), function(lang) {
    return _c('a', {
      staticClass: "tabs__link",
      class: {
        'tabs__link--active': lang === _vm.current
      },
      on: {
        "click": function($event) {
          _vm.select(lang)
        }
      }
    }, [_vm._v(_vm._s(lang))])
  }))
},staticRenderFns: []}

/***/ })
],[12]);


// WEBPACK FOOTER //
// static/js/app.c0ca9f4ddb58265dddfa.js